import React, { useCallback, useEffect, useRef, useState } from "react";
import { shareViaFlutter } from "../utils/shareLink";
import FeedTop from "../components/Feed/Main/FeedTop";
import MarketVoteCard from "../components/Feed/Main/MarketVoteCard";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import usePullToRefresh from "../hooks/usePullToRefresh";
import PullToRefreshIndicator from "../components/Other/PullToRefreshIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as empty,
  faBookmark,
} from "@fortawesome/free-regular-svg-icons";
import { faComment as empty2 } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowUpFromBracket,
  faHeart,
  faTrash,
  faEllipsisH,
  faBookmark as saved,
  faBan,
  faRepeat,
  faFlag,
  faEllipsisV,
  faPlay,
  faPause,
  faMagnifyingGlass,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import {
  getAllPost,
  deleteComment,
  repostPost,
  addComment,
  likeDislike,
  getComment,
  deletePost,
  savePost,
  getMyPost,
  reportPostApi,
  blockUnblockUserApi,
  undoRepostPost,
  getGuideSetting,
  getLinkPreview,
} from "../api/user";
import {
  extractFirstUrl,
  splitTextAndUrls,
  getTextOnlyLength,
  trimTextPreservingUrls,
} from "../utils/urlUtils";
import { renderPostHtml } from "../utils/postContent";
import PostCaption from "../components/Feed/PostCaption";
import LinkPreviewCard from "../components/LinkPreviewCard/LinkPreviewCard";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import NewTraderGuide from "../components/guide/NewTraderGuide";
import { useNewTraderGuide } from "../context/NewTraderGuideContext";
import PageContainer from "../components/pages/PageContainer";
import InfiniteScroll from "react-infinite-scroll-component";
import PostListSkeleton from "../components/Skeleton/PostListSkeleton";
import ListSkeleton from "../components/Skeleton/ListSkeleton";
import useDelayedFlag from "../components/Skeleton/useDelayedFlag";
import GreenTick from "../images/green-tick.png";
import BlockReportModal from "../components/Modals/blockandreport";
import UndoRepostModal from "../components/Modals/repostModal";
import { PreviewVideo } from "./previewVideo";
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import GameSideBar from "../components/Games/GameSideBar";
import { BASE_URL } from "../config/api";
import Default from "./Default.svg";
import {
  IconExit,
  CommentIcon,
  HeartFilledIcon,
  HeartIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon,
  TheDotsIcon,
  SaveIconFill,
} from "../icons/icons";

import FeedCard from "../components/FeedCard/FeedCard";
import FeedGuideSteps from "../components/guide/FeedGuideSteps";
import { SkeletonBlock } from "../components/Skeleton/Skeleton";

const debounce = (func, delay) => {
  let debounceTimer;
  return function (...args) {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

let hasScrolled = false;

const FeedPage = (props) => {
  const isMobileView = document.body.clientWidth <= 768;
  // Two layouts supply this context in two shapes: AuthLayout passes an array
  // ([sidebarToggle]) to the top-level routes, while the Contest layout passes an
  // object ({search, handleChange}) to its children — and this feed now renders
  // under both. Array-destructuring an object throws, so read it defensively.
  const outletContext = useOutletContext();
  const sidebarToggle = Array.isArray(outletContext)
    ? outletContext[0]
    : outletContext?.sidebarToggle;
  const { postId } = useParams();
  // Client Rev 2 (desktop Private League Home 10) needs the league feed's empty
  // state to differ for the organiser, and its CTA to open the league composer.
  // `game.user_id` is the organiser; the host screen (LeagueHome) owns the modal,
  // so it passes the opener down rather than this file reaching for it.
  const onCompose = props.onCompose;
  const isLeagueOrganizer = (() => {
    try {
      const me = JSON.parse(localStorage.getItem("userInfo") || "null");
      return !!(
        me?.id &&
        props.game?.user_id &&
        String(me.id) === String(props.game.user_id)
      );
    } catch (e) {
      return false;
    }
  })();
  const { guideActive: newTraderGuideActive, guideStep: newTraderGuideStep } =
    useNewTraderGuide();
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("userInfo")),
  );
  const game_id = props.gameId ?? null;
  const [pausedVideoId, setPausedVideoId] = useState(null);
  const slug = props.slug ?? null;
  const game = props.game ?? null;
  // Embedded mode: the feed is rendered INSIDE another screen (a league's Home),
  // which already owns the top bar, the page container and the league navigation.
  // In that mode this component contributes the feed and nothing else — without
  // it, the page gets two headers and two sets of league nav.
  const embedded = !!props.embedded;
  const Shell = embedded ? "div" : PageContainer;
  const shellProps = embedded ? {} : { gamePage: game_id && true };
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [commentOpenStates, setCommentOpenStates] = useState({});
  const [newComment, setNewComment] = useState("");
  const [commentImage, setCommentImage] = useState(null);
  const [commentImagePreview, setCommentImagePreview] = useState(null);
  const [postComments, setPostComments] = useState({});
  const [replyingTo, setReplyingTo] = useState(null);
  const [expandedReplies, setExpandedReplies] = useState({});
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loginUserId, setLoginUserId] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [linkPreviewData, setLinkPreviewData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newid, setNewId] = useState("");
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [showFullRepostDescription, setShowFullRepostDescription] = useState(
    [],
  );
  const [apiCall1, setApiCall1] = useState(false);
  // Open three-dot menu, by post id (not list index, which shifted after a
  // delete and left the next post's menu open). One menu at a time.
  const [openMenuPostId, setOpenMenuPostId] = useState(null);
  const [guideIcon, setGuideIcon] = useState(false);
  const [showFeedGuide, setShowFeedGuide] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [guideButtonPosition, setGuideButtonPosition] = useState(() => {
    const isMobile = window.innerWidth <= 768;
    return {
      bottom: isMobile ? 80 : 16,
      right: 16,
    };
  });
  const [isGuideDragging, setIsGuideDragging] = useState(false);
  const [guideDragOffset, setGuideDragOffset] = useState({ x: 0, y: 0 });
  const [guideDragStartPosition, setGuideDragStartPosition] = useState({
    x: 0,
    y: 0,
  });
  const [hasGuideDraggedSignificantly, setHasGuideDraggedSignificantly] =
    useState(false);
  const [isBlockOpen, setIsBlockOpen] = useState(false);
  const [postType, setPostType] = useState("");
  const [blockReportIDs, setBlockReportIDs] = useState("");
  const [reportComment, setReportComment] = useState("");
  const [videoPlaying, setVideoPlaying] = useState([]);
  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;
  const [postUndo, setPostUndo] = useState(false);
  const [postUndoId, setPostUndoID] = useState("");
  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const commentSubmittingRef = useRef(false);
  const [attachments, setAttachments] = useState("");
  const [apiCall, setApiCall] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  const [search, setSearch] = useState("");
  // Home-feed search is collapsed by default; the header search icon toggles it.
  // When active, the search field expands into the Leaderboard / League Play space.
  const [feedSearchActive, setFeedSearchActive] = useState(false);
  // Mobile comment modal state
  const [mobileCommentModal, setMobileCommentModal] = useState({
    isOpen: false,
    postId: null,
    postIndex: null,
  });
  // Swipe to close state for mobile comment modal
  const [commentModalSwipe, setCommentModalSwipe] = useState({
    startY: 0,
    currentY: 0,
    isDragging: false,
  });
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [showVideos, setShowVideos] = useState(
    new Array(posts?.length).fill(false),
  );
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
  const videoRefs = useRef([]);

  useEffect(() => {
    const fetchGuideStatus = async () => {
      try {
        const response = await getGuideSetting();
        if (response?.data?.success && response?.data?.status === 200) {
          setGuideIcon(response?.data?.show_icon);
        }
      } catch (error) {
        console.log("Error fetching guide status:", error);
      }
    };

    fetchGuideStatus();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "g") {
        event.preventDefault();
        setShowFeedGuide(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    const checkSidebarOpen = () => {
      const isOpen = !sidebar.classList.contains('-translate-x-full');
      setIsSidebarOpen(isOpen);
    };

    checkSidebarOpen();

    const observer = new MutationObserver(checkSidebarOpen);
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const handleGuideDragStart = (e) => {
    setIsGuideDragging(true);
    const rect = e.currentTarget.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    setGuideDragOffset({
      x: clientX - rect.left,
      y: clientY - rect.top,
    });

    setGuideDragStartPosition({ x: clientX, y: clientY });
    setHasGuideDraggedSignificantly(false);
  };

  const handleGuideDragMove = (e) => {
    if (!isGuideDragging) return;
    e.preventDefault();

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const dragDistance = Math.sqrt(
      Math.pow(clientX - guideDragStartPosition.x, 2) +
        Math.pow(clientY - guideDragStartPosition.y, 2),
    );

    if (dragDistance > 10) {
      setHasGuideDraggedSignificantly(true);
    }

    const newRight = window.innerWidth - clientX - guideDragOffset.x;
    const newBottom = window.innerHeight - clientY - guideDragOffset.y;

    const clampedRight = Math.max(
      8,
      Math.min(newRight, window.innerWidth - 48),
    );
    const clampedBottom = Math.max(
      8,
      Math.min(newBottom, window.innerHeight - 48),
    );

    setGuideButtonPosition({ right: clampedRight, bottom: clampedBottom });
  };

  const handleGuideDragEnd = () => {
    setIsGuideDragging(false);
    setTimeout(() => setHasGuideDraggedSignificantly(false), 100);
  };

  useEffect(() => {
    if (!isGuideDragging) return;

    const handleMouseMove = (event) => handleGuideDragMove(event);
    const handleTouchMove = (event) => handleGuideDragMove(event);

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleGuideDragEnd);
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchend", handleGuideDragEnd);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleGuideDragEnd);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleGuideDragEnd);
    };
  }, [isGuideDragging, guideDragOffset, guideDragStartPosition]);

  //For Video

  const videosRef = useRef({});
  const [playing, setPlaying] = useState({});
  const [isMuted, setIsMuted] = useState(true); // Global mute state
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const location = useLocation();
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    hasScrolledRef.current = false; // ✅ Reset when FeedPage mounts
  }, [location.pathname]); // Runs only when the component mounts

  const loadedVideosRef = useRef(new Set()); // Track which videos are loaded
  const commentTextareaRef = useRef(null);
  const commentImageInputRef = useRef(null);
  const commentModalRef = useRef(null);

  const handleVideoCanPlay = (id) => {
    const video = videosRef.current[id];
    if (video) {
      video.pause(); // Pause by default
      setPlaying((prev) => ({ ...prev, [id]: false }));
      setIsLoading((prev) => ({ ...prev, [id]: false }));

      // Track loaded video
      loadedVideosRef.current.add(id);

      // After all videos loaded, check visibility
      checkAndPlayFirstVisibleVideo();
    }
  };

  const checkAndPlayFirstVisibleVideo = () => {
    let firstVisibleVideoId = null;

    Object.entries(videosRef.current).forEach(([id, video]) => {
      if (!video) return;
      const rect = video.getBoundingClientRect();

      // Check if at least 75% is visible
      const visibleHeight =
        Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      const visibleRatio = visibleHeight / rect.height;

      if (visibleRatio >= 0.75 && !firstVisibleVideoId) {
        firstVisibleVideoId = id;
      }
    });

    // Play only the first visible video
    if (firstVisibleVideoId) {
      const video = videosRef.current[firstVisibleVideoId];
      if (video) {
        video.play().catch((e) => console.warn("Autoplay blocked:", e));
        setPlaying((prev) => ({ ...prev, [firstVisibleVideoId]: true }));
      }
    }
  };

  // useEffect(() => {
  //   const video = videosRef.current[posts.id];
  //   if (video) {
  //     video.load(); // ✅ Force browser to load video immediately
  //   }
  // }, []);

  const handleVisibility = (id, isVisible) => {
    const video = videosRef.current[id];
    if (video) {
      if (isVisible) {
        video.play().catch((e) => console.warn("Autoplay blocked:", e));
        setPlaying((prev) => ({ ...prev, [id]: true }));
      } else {
        video.pause();
        setPlaying((prev) => ({ ...prev, [id]: false }));
      }
    }
  };

  useEffect(() => {
    if (document.body.clientWidth <= 768) return;

    let currentlyPlayingId = null;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("data-id");
          const video = videosRef.current[id];
          if (!video) return;

          if (entry.isIntersecting) {
            if (currentlyPlayingId && currentlyPlayingId !== id) {
              const prevVideo = videosRef.current[currentlyPlayingId];
              if (prevVideo) {
                prevVideo.pause();
                setPlaying((prev) => ({
                  ...prev,
                  [currentlyPlayingId]: false,
                }));
              }
            }

            video.play().catch((e) => console.warn("Autoplay blocked:", e));
            setPlaying((prev) => ({ ...prev, [id]: true }));
            currentlyPlayingId = id;
          } else {
            video.pause();
            setPlaying((prev) => ({ ...prev, [id]: false }));
          }
        });
      },
      { threshold: 0.75 },
    );

    Object.values(videosRef.current).forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videosRef.current).forEach((video) => {
        if (video) observer.unobserve(video);
      });
      observer.disconnect();
    };
  }, [posts]);

  const checkVideosInView = () => {
    let newPlayingVideoId = playingVideoId;
    Object.entries(videosRef.current).forEach(([id, video]) => {
      if (video) {
        const rect = video.getBoundingClientRect();
        const videoHeight = rect.bottom - rect.top;
        const videoVisibleHeight =
          Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        // Check if at least 10% of the video is visible in the viewport
        const isAtLeast10PercentVisible =
          videoVisibleHeight / videoHeight >= 0.1;
        const completelyOutOfView =
          rect.bottom <= 0 || rect.top >= window.innerHeight;

        if (isAtLeast10PercentVisible) {
          newPlayingVideoId = id;
        }

        if (completelyOutOfView && playingVideoId === id) {
          video.pause();
          setPausedVideoId(null);
          newPlayingVideoId = null;
        }
      }
    });

    // If a new video should be played, play it and update state
    if (newPlayingVideoId !== playingVideoId) {
      Object.values(videosRef.current).forEach((v) => v?.pause());
      if (newPlayingVideoId) {
        // alert('dg');
        videosRef.current[newPlayingVideoId]
          ?.play()
          .catch(() => console.warn("Autoplay blocked"));
        //setPausedVideoId(null);
      }
      setPlayingVideoId(newPlayingVideoId);

      // 🧠 Clear the play icon if it's no longer on the currently playing video

      if (pausedVideoId && pausedVideoId !== playingVideoId) {
        setPausedVideoId(null);
      }
    }
  };

  // Attach scroll event listener
  useEffect(() => {
    checkVideosInView(); // Check on mount
    window.addEventListener("scroll", checkVideosInView);

    return () => {
      window.removeEventListener("scroll", checkVideosInView);
    };
  }, [playingVideoId]);

  const togglePlay = (id) => {
    const video = videosRef.current[id];
    if (video) {
      const isPlaying = playing[id] ?? false; // default to false
      if (isPlaying) {
        //  alert('in if');
        video.pause();
        setPausedVideoId(id); // show overlay
      } else {
        //  alert('in else');
        video.play();
        setPausedVideoId(null); // hide overlay
      }

      setPlaying((prev) => ({ ...prev, [id]: !isPlaying }));
    }
  };

  const toggleMute = () => {
    setIsMuted((prevMuted) => {
      const newMuteState = !prevMuted;
      Object.values(videosRef.current).forEach((video) => {
        if (video) video.muted = newMuteState;
      });
      return newMuteState;
    });
  };

  //

  let fullImageUrl = null;
  let extension = null;

  // Track keyboard height so the comment modal slides above the keyboard
  // Also lock body scroll when modal is open to prevent background scrolling
  useEffect(() => {
    if (!mobileCommentModal.isOpen) {
      setKeyboardHeight(0);
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = "hidden";

    const handleViewportResize = () => {
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const windowHeight = window.innerHeight;
        const kbHeight = windowHeight - viewportHeight;
        setKeyboardHeight(Math.max(0, kbHeight));

        // Ensure input stays visible after keyboard resize
        if (kbHeight > 0 && commentTextareaRef.current) {
          setTimeout(() => {
            commentTextareaRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "end",
            });
          }, 100);
        }
      }
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportResize);
      window.visualViewport.addEventListener("scroll", handleViewportResize);
      handleViewportResize();
    }

    return () => {
      document.body.style.overflow = "";
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          handleViewportResize,
        );
        window.visualViewport.removeEventListener(
          "scroll",
          handleViewportResize,
        );
      }
    };
  }, [mobileCommentModal.isOpen]);

  // Block background scroll when comment modal is open (non-passive listener required)
  useEffect(() => {
    const modalEl = commentModalRef.current;
    if (!mobileCommentModal.isOpen || !modalEl) return;

    const handleTouchMove = (e) => {
      // Allow scrolling inside the comment textarea, but contain it
      const textarea = e.target.closest("textarea");
      if (textarea) {
        const atTop = textarea.scrollTop <= 0;
        const atBottom =
          textarea.scrollTop + textarea.clientHeight >=
          textarea.scrollHeight - 1;
        const isScrollingUp =
          e.touches[0].clientY > (handleTouchMove._lastY || 0);
        const isScrollingDown =
          e.touches[0].clientY < (handleTouchMove._lastY || 0);
        handleTouchMove._lastY = e.touches[0].clientY;

        // If textarea is scrollable (content overflows), allow internal scroll
        const isScrollable = textarea.scrollHeight > textarea.clientHeight;
        if (isScrollable) {
          // Block only when at boundary to prevent outer feed from scrolling
          if ((atTop && isScrollingUp) || (atBottom && isScrollingDown)) {
            e.preventDefault();
          }
          // Otherwise let it scroll naturally within the textarea
        } else {
          // Textarea has no overflow, block to prevent outer scroll
          e.preventDefault();
        }
        return;
      }

      const scrollable = modalEl.querySelector("[data-comment-scroll]");
      if (scrollable && scrollable.contains(e.target)) {
        // Allow scrolling inside the comment list, but contain it
        const atTop = scrollable.scrollTop <= 0;
        const atBottom =
          scrollable.scrollTop + scrollable.clientHeight >=
          scrollable.scrollHeight;
        const isScrollingUp =
          e.touches[0].clientY > (handleTouchMove._lastY || 0);
        const isScrollingDown =
          e.touches[0].clientY < (handleTouchMove._lastY || 0);
        handleTouchMove._lastY = e.touches[0].clientY;

        // If at boundary and scrolling further in that direction, block it
        if ((atTop && isScrollingUp) || (atBottom && isScrollingDown)) {
          e.preventDefault();
        }
      } else {
        // Outside the scrollable area — always block
        e.preventDefault();
      }
    };

    modalEl.addEventListener("touchmove", handleTouchMove, { passive: false });
    return () => {
      modalEl.removeEventListener("touchmove", handleTouchMove);
    };
  }, [mobileCommentModal.isOpen]);

  //Use Effect
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
      zoom: false,
    });
    lightbox.init();

    return () => {
      localStorage.setItem("toggle", "false");
      lightbox.destroy();
      lightbox = null;
    };
  }, [posts]);

  const openCommentImage = (imageUrl) => {
    import("photoswipe").then((PhotoSwipeModule) => {
      const PhotoSwipe = PhotoSwipeModule.default;
      const img = new Image();
      img.onload = () => {
        const pswp = new PhotoSwipe({
          dataSource: [
            { src: imageUrl, w: img.naturalWidth, h: img.naturalHeight },
          ],
          index: 0,
          zoom: false,
        });
        pswp.init();
      };
      img.src = imageUrl;
    });
  };

  useEffect(() => {
    localStorage.removeItem("game_type");
    localStorage.removeItem("isAuthenticated");
    if (!isDataFeteched) fetchPost();
  }, [isDataFeteched]);

  useEffect(() => {
    const handleCustomProfileEvent = async (event) => {
      if (event?.detail?.posts) {
        setPosts(event?.detail?.posts);
      }
    };

    window.addEventListener("feedDataEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("feedDataEvent", handleCustomProfileEvent);
    };
  }, [window.addEventListener]);

  useEffect(() => {
    let user_id = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {};
    if (user_id && user_id?.id) {
      setLoginUserId(user_id?.id);
    }
  }, []);

  useEffect(() => {
    const video = document.querySelector("video"); // Select the video element

    if (video) {
      video.muted = true; // Ensure it's muted
      video.play().catch((err) => console.warn("Autoplay blocked:", err));
    }
  }, []);

  useEffect(() => {
    const postIdToScroll = postId;
    if (postIdToScroll) {
      setCommentOpenStates((prevStates) => ({
        ...prevStates,
        [postIdToScroll]: true,
      }));
      fetchPostNotification(postIdToScroll);
    }
  }, [posts]);

  if (game) {
    const imagePath =
      game.game_image && game.game_image.length > 0
        ? game.game_image[0].image
        : null;

    const filename = imagePath ? imagePath.split("/").pop() : null;

    fullImageUrl = filename
      ? `${BASE_URL}/storage/upload/game/image/${filename}`
      : Default;

    extension = fullImageUrl.split(".").pop().toLowerCase();
  }

  // Where a profile picture / handle in this feed points.
  //
  // Client Rev 3 item 9: inside league screens a profile picture must NOT be a
  // link to the user's main QUSHi profile record. A league is its own world with
  // its own record — the same "keep the user inside the league context" rule the
  // client set for League Details — so the picture opens that member's LEAGUE
  // profile (/:slug/profile/:id), which reads their standing through this league
  // instead of their main account.
  //
  // Outside a league nothing changes: an id opens that user's public profile,
  // and no id means "me" and opens the private /profile dashboard.
  const profilePath = (targetUserId) => {
    if (!(game_id && slug))
      return targetUserId ? `/profile/${targetUserId}` : "/profile";
    // In a league there is no private/public split — every member, you included,
    // is read through the league.
    const id = targetUserId || loginUserId;
    return id ? `/${slug}/profile/${id}` : `/contest/${slug}`;
  };

  const navigateToUserProfile = (event, userId) => {
    if (event) event.preventDefault();
    if (!userId) return;
    if (mobileCommentModal?.isOpen) {
      setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
    }
    const profileUrl = game_id
      ? `/${slug}/profile/${userId}`
      : `/profile/${userId}`;
    window.open(profileUrl, "_blank");
  };

  const debouncedFetchOptions = useCallback(
    debounce((searchTerm) => {
      handleChange(searchTerm);
    }, 500),
    [],
  );

  const handleChange = async (searchData) => {
    fetchPost(searchData, 1);
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    debouncedFetchOptions(e.target.value);
  };

  const fetchPost = async (searchData) => {
    try {
      if (!postId) {
        // if (!apiCall1) {
        let params = { page: 1 };

        // Check if game_id is available and add it to the params
        if (game_id) {
          params.game_id = game_id;
        }
        const response = await getAllPost(searchData ? searchData : "", params);
        if (response?.data?.status === 200) {
          const myCustomEvent = new CustomEvent("feedDataEvent", {
            detail: {
              posts: response?.data?.data?.data,
            },
          });
          window.dispatchEvent(myCustomEvent);
          setPosts(response?.data?.data?.data);
          setApiCall1(true);
          setTimeout(() => {
            setApiCall1(true);
          }, 3000);
          setisDataFeteched(true);
          setLoader(false);
        } else {
          setApiCall1(false);
          setLoader(false);
        }
        // }
      }
    } catch (error) {
      setApiCall1(false);
      setLoader(false);
    }
  };

  const fetchPostNotification = async (id) => {
    try {
      if (id) {
        setLoader(true);
        const response = await getMyPost({ post_id: id });
        if (response?.data?.data?.data.length > 0) {
          setisDataFeteched(true);
          setPosts(response.data.data.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleImageLoaded = (event, imageIndex) => {
    const image = event.target;
    const linkElement = image.closest("a");
    linkElement.setAttribute("data-pswp-width", image.naturalWidth);
    linkElement.setAttribute("data-pswp-height", image.naturalHeight);
  };
  const galleryStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gridGap: "20px",
  };

  const imageStyles = {
    width: "auto",
    height: "auto",
    objectFit: "cover",
    // border: "1px solid #ccc",
  };

  const linkStyles = {
    // background: "#f0f0f0",
    // padding: "1px",
    margin: "10px",
  };
  const handleBlockUserCancel = () => {
    setIsBlockOpen(false);
    setPostType("");
    setBlockReportIDs("");
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  useEffect(() => {
    setIsLoading((prevLoadingState) => {
      const newLoadingState = { ...prevLoadingState }; // Preserve previous state
      posts.forEach((post) => {
        if (!(post.id in newLoadingState)) {
          newLoadingState[post.id] = true; // Set only for new posts
        }
      });
      return newLoadingState;
    });
  }, [posts]);

  const handleBlockUser = async () => {
    const res = await blockUnblockUserApi({ user_id: blockReportIDs });
    if (res?.data?.status === 200) {
      setIsBlockOpen(false);
      setPostType("");
      fetchPost();
      toast.success(
        res?.data?.message === "User blocked successfully."
          ? "Trader blocked."
          : res?.data?.message === "User unblocked successfully."
            ? "Trader unblocked."
            : res?.data?.message,
      );
      setBlockReportIDs("");
    } else {
      toast.success(res?.data?.message);
    }
  };

  const handleReportPost = async () => {
    const obj = {
      post_id: blockReportIDs,
      comment: reportComment,
    };
    const res = await reportPostApi(obj);
    if (res?.data?.status === 200) {
      setIsBlockOpen(false);
      setPostType("");
      toast.success("Report submitted.");
      setBlockReportIDs("");
      fetchPost();
      setReportComment("");
    } else {
      toast.success(res?.data?.message);
    }
  };

  const handleBlock = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };
  const handleReport = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };

  const fetchMorePost = async () => {
    try {
      setLoader(true);
      let params = { page: page };

      // Check if game_id is available and add it to the params
      if (game_id) {
        params.game_id = game_id;
      }
      const response = await getAllPost("", params);
      if (response?.data?.status === 200) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
        setPage((pagePre) => pagePre + 1);
        setApiCall(true);
        setLoader(false);
      } else {
        setApiCall(false);
        setHasMore(false);
        setLoader(false);
      }
    } catch (error) {
      setApiCall(false);
      setLoader(false);
    } finally {
      setApiCall(false);
      setLoader(false);
    }
  };

  const toggleDropdown = (postId) => {
    setOpenMenuPostId((prev) => (prev === postId ? null : postId));
  };

  // Close the open post menu on an outside click / tap or Esc.
  useEffect(() => {
    if (openMenuPostId === null) return undefined;
    const onPointer = (e) => {
      if (!e.target.closest?.("[data-post-menu]")) setOpenMenuPostId(null);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpenMenuPostId(null);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("touchstart", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("touchstart", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [openMenuPostId]);

  const handleCommentToggle = async (index, id, isOpen) => {
    // For mobile devices, open the modal instead of inline comments
    if (isMobileView) {
      setMobileCommentModal({
        isOpen: true,
        postId: id,
        postIndex: index,
      });
      // Fetch comments for the modal
      setLoadingComment(true);
      try {
        const response = await getComment(id);
        if (response?.status === 200) {
          const sortedChats = response?.data?.data.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at),
          );
          setPostComments((prevComments) => ({
            ...prevComments,
            [id]: sortedChats,
          }));
        }
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setLoadingComment(false);
      }
      return;
    }

    // Desktop behavior - keep existing inline logic
    setLoadingComment(true);
    try {
      isOpen = isOpen !== undefined ? isOpen : !commentOpenStates[index];

      if (!isOpen) {
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: false,
        }));
        return;
      }
      const response = await getComment(id);
      if (response?.status === 200) {
        setTimeout(() => {
          setLoadingComment(false);
        }, 1000);
        setCommentOpenStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });

        const sortedChats = response?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at),
        );

        setPostComments((prevComments) => ({
          ...prevComments,
          [id]: sortedChats,
        }));

        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: isOpen,
        }));
      }
    } catch (error) {
      setTimeout(() => {
        setLoadingComment(false);
      }, 1000);
    }
  };

  const handleAddComment = async (postId, index) => {
    if (commentSubmittingRef.current) return;

    if (newComment.length <= 255 && (newComment.trim() || commentImage)) {
      commentSubmittingRef.current = true;
      setIsDisabled(true);

      const formData = new FormData();
      formData.append("post_id", postId);
      if (replyingTo) formData.append("parent_id", replyingTo.commentId);
      if (newComment.trim()) formData.append("comment", newComment);
      if (commentImage) formData.append("image", commentImage);

      try {
        const response = await addComment(formData);
        if (response.status === 200) {
          if (response.data?.data?.moderation_status === "pending_review") {
            toast.success(response.data?.data?.message);
          }

          // Auto-expand replies for the parent being replied to
          if (replyingTo) {
            setExpandedReplies((prev) => ({
              ...prev,
              [replyingTo.commentId]: true,
            }));
          }

          // Fetch updated comments
          const commentsResponse = await getComment(postId);
          if (commentsResponse?.status === 200) {
            const sortedChats = commentsResponse?.data?.data.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at),
            );
            setPostComments((prevComments) => ({
              ...prevComments,
              [postId]: sortedChats,
            }));
          }

          // For mobile modal, keep it open and just clear the input
          if (isMobileView && mobileCommentModal.isOpen) {
            // Update the comment count in the posts array
            setPosts((prevPosts) =>
              prevPosts.map((post) => {
                if (post?.repost?.id === postId) {
                  return {
                    ...post,
                    repost: {
                      ...post.repost,
                      total_comments: (post.repost.total_comments || 0) + 1,
                    },
                  };
                } else if (post.id === postId) {
                  return {
                    ...post,
                    total_comments: (post.total_comments || 0) + 1,
                  };
                }
                return post;
              }),
            );
            setNewComment("");
            setCommentImage(null);
            setCommentImagePreview(null);
            setReplyingTo(null);
            if (commentTextareaRef.current) {
              commentTextareaRef.current.style.height = "auto";
            }
            setIsDisabled(false);
            return;
          }

          // Desktop behavior
          handleCommentToggle(index, postId, true);
          setIsDisabled(false);
          setCommentOpenStates((prevStates) => ({
            ...prevStates,
            [postId]: false,
          }));
          setNewComment("");
          setCommentImage(null);
          setCommentImagePreview(null);
          setReplyingTo(null);
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
        }
      } catch (error) {
        setIsDisabled(false);
        if (!error.response?.status) {
          toast.error("Could not post the comment. Try again.");
        }
      } finally {
        commentSubmittingRef.current = false;
      }
    } else {
      toast.error("Comment must be 255 characters or fewer.");
    }
  };

  const handleReply = (comment, postId) => {
    setReplyingTo({
      commentId: comment.id,
      userName: comment.user.user_name,
      postId,
    });
    setNewComment(`@${comment.user.user_name} `);
    if (commentTextareaRef.current) {
      commentTextareaRef.current.focus();
    }
  };

  const handleCancelReply = () => {
    setReplyingTo(null);
    setNewComment("");
  };

  const toggleReplies = (commentId) => {
    setExpandedReplies((prev) => ({ ...prev, [commentId]: !prev[commentId] }));
  };

  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime(),
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30;
    const yearsInMs = daysInMs * 365;

    if (timeDifference < secondsInMs) {
      return "just now";
    } else if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s ago";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m ago";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h ago";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d ago";
    } else if (timeDifference < yearsInMs) {
      return Math.round(timeDifference / monthsInMs) + "mo ago";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y ago";
    }
  }

  const handleLikeDislike = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id === postId) {
        val.is_like_by_me = !val.is_like_by_me;
        val.total_likes =
          val.is_like_by_me === true
            ? val.total_likes + 1
            : val.total_likes - 1;
      } else if (val?.repost?.id === postId) {
        val.repost.is_like_by_me = !val.repost.is_like_by_me;
        val.repost.total_likes =
          val.repost.is_like_by_me === true
            ? val.repost.total_likes + 1
            : val.repost.total_likes - 1;
      }
      return val;
    });
    setPosts(postssss);

    setIsDisabled(true);
    try {
      const response = await likeDislike(postId);
      if (response.status === 200) {
        setLoading(false);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id === postId) {
            val.is_like_by_me = false;
            val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
          } else if (val?.repost?.id === postId) {
            val.repost.is_like_by_me = false;
            val.repost.total_likes =
              val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to update like/dislike status");
      }
    } catch (error) {
      const postssss = posts.map((val) => {
        if (val?.id === postId) {
          val.is_like_by_me = false;
          val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
        } else if (val?.repost?.id === postId) {
          val.repost.is_like_by_me = false;
          val.repost.total_likes =
            val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
        }
        return val;
      });
      setPosts(postssss);
      setIsDisabled(false);
    }
  };

  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await deletePost(newid);
      if (response.status === 200) {
        setPosts((prevPosts) => prevPosts.filter((post) => post.id !== newid));
        toast.success("Post deleted.");
        fetchPost();
        handleCloseModal();
      } else {
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      toast.error("Could not delete the post. Try again.");
    }
  };

  const handleDeleteComment = async (id) => {
    setIsDisabled(true);
    try {
      // const isConfirmed = window.confirm("Are you sure you want to delete this post?");
      // if (isConfirmed) {
      // Make API call to delete the post
      const response = await deleteComment(id); // You need to implement this function

      if (response.status === 200) {
        // For mobile modal, refresh comments in the modal
        if (
          isMobileView &&
          mobileCommentModal.isOpen &&
          mobileCommentModal.postId
        ) {
          const commentsResponse = await getComment(mobileCommentModal.postId);
          if (commentsResponse?.status === 200) {
            const sortedChats = commentsResponse?.data?.data.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at),
            );
            setPostComments((prevComments) => ({
              ...prevComments,
              [mobileCommentModal.postId]: sortedChats,
            }));

            // Update the comment count in the posts array
            setPosts((prevPosts) =>
              prevPosts.map((post) => {
                if (post?.repost?.id === mobileCommentModal.postId) {
                  return {
                    ...post,
                    repost: {
                      ...post.repost,
                      total_comments: Math.max(
                        0,
                        (post.repost.total_comments || 1) - 1,
                      ),
                    },
                  };
                } else if (post.id === mobileCommentModal.postId) {
                  return {
                    ...post,
                    total_comments: Math.max(0, (post.total_comments || 1) - 1),
                  };
                }
                return post;
              }),
            );
          }
          setIsDisabled(false);
          return;
        }

        // Remove the deleted post from the state

        // toast.success("Comment deleted successfully");
        fetchPost();
        handleCommentToggle(true);
        setLoading(false);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        toast.error("Could not delete the comment. Try again.");
        throw new Error("Failed to delete the post");
      }
      // }
    } catch (error) {
      setIsDisabled(false);
      // Handle error
    }
  };

  const handleUndoRepost = async () => {
    try {
      const res = await undoRepostPost(postUndoId);
      if (res.status === 200) {
        fetchPost();
        setPostUndo(false);
        setIsDisabled(false);
      }
      if (!res.ok) {
        setIsDisabled(false);
      }
    } catch (error) {
      setIsDisabled(false);
    }
  };

  const handleUndoCancel = () => {
    setPostUndo(false);
  };

  const handleRepost = async (postId, userId, id) => {
    if (userId == loginUserId) {
      setPostUndo(true);
      setPostUndoID(id);
    } else {
      setIsDisabled(true);
      try {
        const response = await repostPost(postId);
        if (response.status === 200) {
          fetchPost();
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to update like/dislike status");
        }
      } catch (error) {
        setIsDisabled(false);
      }
    }
  };
  const handleSavePost = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id === postId) {
        val.is_saved = !val.is_saved;
      } else if (val?.repost?.id === postId) {
        val.repost.is_saved = !val.repost.is_saved;
      }
      return val;
    });
    setPosts(postssss);
    setIsDisabled(true);
    try {
      const response = await savePost(postId);
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost();
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id === postId) {
            val.is_saved = false;
          } else if (val?.repost?.id === postId) {
            val.repost.is_saved = false;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to save post");
      }
    } catch (error) {
      setIsDisabled(false);
    }
  };

  // Fetch link preview metadata for any post whose description contains a URL
  useEffect(() => {
    if (!posts || posts.length === 0) return;
    posts.forEach((post) => {
      const postId = post?.repost?.id || post.id;
      const description = post?.description;
      if (!description || linkPreviewData[postId] !== undefined) return;
      const url = extractFirstUrl(description);
      if (!url) return;
      // Immediately store the URL + domain so the card renders right away
      let domain = null;
      try {
        domain = new URL(url).hostname.replace(/^www\./, "");
      } catch {}
      const minimal = {
        url,
        site_name: domain,
        title: null,
        description: null,
        image: null,
        _loading: true,
      };
      setLinkPreviewData((prev) => ({ ...prev, [postId]: minimal }));
      getLinkPreview(url)
        .then((data) => {
          // Use OG data if available, fall back to minimal
          const resolved =
            data && (data.title || data.description || data.image)
              ? data
              : {
                  url,
                  site_name: data?.site_name || domain,
                  title: null,
                  description: null,
                  image: null,
                };
          setLinkPreviewData((prev) => ({ ...prev, [postId]: resolved }));
        })
        .catch(() => {
          // Keep minimal card on failure
          setLinkPreviewData((prev) => ({
            ...prev,
            [postId]: {
              url,
              site_name: domain,
              title: null,
              description: null,
              image: null,
            },
          }));
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts]);

  // Render description text with URLs as clickable links
  const renderTextWithLinks = (text, hideUrl = false) => {
    if (!text) return null;
    // Posts now store sanitized B/I/U HTML. When a link-preview card is shown
    // for this post, strip the bare URL text so it isn't duplicated.
    const str = hideUrl
      ? String(text).replace(/https?:\/\/[^\s<]+/g, "")
      : String(text);
    return (
      <span
        className="post-content"
        dangerouslySetInnerHTML={{ __html: renderPostHtml(str) }}
      />
    );
  };

  const renderDescriptionDynamicLineBreaks = (description) => {
    const regex = /(\n+)/g;
    const parts = description && description.split(regex);

    if (!description || description == null) {
      return null;
    }
    return parts.map((part, index) => {
      if (part.match(regex)) {
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // const handleCloseModal = () => {
  //     setIsModalOpen(false);
  // };

  const handleDeletePost = async (postId) => {
    // alert(postId);
    handleOpenModal();
    setNewId(postId);
  };

  const handleEditClick = (postId) => {
    navigate(`/${slug}/edit-feed/${postId}`);
  };

  const handleShare = async (id) => {
    const urlToShare = `https://app.qushi.io/feed/${id}`;

    const shareData = {
      title: "QUSHI",
      text: "Check out this!",
      url: urlToShare,
    };
    // Inside the QUSHi app the native sheet is opened by Flutter, over the
    // WebView, rather than by the WebView itself — see utils/shareLink.js for
    // why that matters (the WebView's scroll view never comes back right after
    // presenting its own sheet). Everything below is untouched and still runs in
    // a browser, and in an app build that does not handle the event yet.
    if (shareViaFlutter(shareData)) return;
    try {
      if (navigator.share) {
        await navigator.clipboard.writeText(urlToShare);
        await navigator.share(shareData);
      } else {
        const el = document.createElement("textarea");
        el.value = urlToShare;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        const shareLinkPrompt = `Link copied\nShare this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const handleVideoClick_BKP = (index) => {
    const updatedShowVideos = [...showVideos];
    updatedShowVideos[index] = true;
    setShowVideos(updatedShowVideos);
    const videoRef = videoRefs.current[index];
    if (videoRef) {
      videoRef.play();
    }
  };

  const handleVideoClick = (postIndex, imageIndex) => {
    const key = `${postIndex}-${imageIndex}`;
    const videoRef = videoRefs.current[key];

    if (videoRef) {
      if (videoPlaying[key]) {
        videoRef.pause();
        setVideoPlaying((prev) => ({ ...prev, [key]: false }));
      } else {
        Object.keys(videoRefs.current).forEach((otherKey) => {
          if (otherKey !== key && videoRefs.current[otherKey]) {
            videoRefs.current[otherKey].pause();
            setVideoPlaying((prev) => ({ ...prev, [otherKey]: false }));
          }
        });
        videoRef
          .play()
          .then(() => {
            setVideoPlaying((prev) => ({ ...prev, [key]: true }));
          })
          .catch((error) => {
            console.error("Error playing video:", error);
          });
      }
    } else {
      setVideoPlaying((prev) => ({ ...prev, [key]: true }));
      const updatedShowVideos = [...showVideos];
      updatedShowVideos[postIndex] = true;
      if (videoRef) {
        videoRef.play();
      }
      setShowVideos(updatedShowVideos);
      console.warn(`No videoRef found for key: ${key}`);
    }
  };

  const handleVideoClick1 = (index) => {
    const updatedShowVideos = [...showVideos];
    updatedShowVideos[index] = true;

    setShowVideos(updatedShowVideos);

    const updatedVideoPlaying = [...videoPlaying];
    const videoRef = videoRefs.current[index];

    if (videoRef) {
      if (videoRef.paused) {
        videoRef.play();
        updatedVideoPlaying[index] = true;
      } else {
        videoRef.pause();
        updatedVideoPlaying[index] = false;
      }
      setVideoPlaying(updatedVideoPlaying);
    }
  };

  const getVideoThumbnail = (videoUrl) => {
    const video1 = videoUrl + ".jpg";
    return video1;
  };
  document.addEventListener("DOMContentLoaded", function () {
    function updateImageStyles() {
      const images = document.querySelectorAll(".pswp__img");
      images.forEach((img) => {});
    }

    document.addEventListener("pswp:afterInit", function (e) {
      updateImageStyles();
    });

    document.addEventListener("pswp:change", function (e) {
      updateImageStyles();
    });
  });
  const navigate = useNavigate();

  const handleExitGame = () => {
    localStorage.removeItem("game_type");
    localStorage.removeItem("isAuthenticated");
    navigate("/contest/my-games", { state: { viewMode: "member" } });
  };

  const gameLeaderboard = () => {
    navigate(`/${slug}/leaderboard`);
  };

  // For Mobile
  const [commentBox, setCommentBox] = useState(false);
  const { post_image, total_likes, updated_at, description } = posts;
  const user = { name: posts?.user?.user_name?.replace(/^@/, ""), avatar: posts?.user?.image };
  const media = {
    type: post_image?.length && post_image[0].is_video ? "video" : "image",
    url: post_image?.length && post_image[0].image,
  };
  const caption = description;
  const initialComments = [
    { user: "Jane", text: "Wow! Looks amazing!", replies: [] },
    { user: "Alex", text: "I wish I was there!", replies: [] },
  ];
  const [liked, setLiked] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [postComments1, setPostComments1] = useState(initialComments);
  const [replyText, setReplyText] = useState("");
  const [replyIndex, setReplyIndex] = useState(null);

  // Never revert to a skeleton: only the truly-empty first load qualifies.
  // Client: "we should not show post skeletons when there are no posts to load."
  //
  // This used to read `loading && posts.length === 0`, and `loading` is the wrong
  // flag — the same trap the empty state above already had to climb out of. It is
  // initialised true and the post fetch NEVER clears it (only the like and
  // delete-comment handlers do), so on a feed that genuinely has no posts both
  // halves stayed true forever: 250ms after mount, three post-card skeletons
  // appeared under the empty state and stayed there, promising content that was
  // never coming. Measured on a league with 0 posts: 16 skeleton nodes on screen.
  //
  // `isDataFeteched` is the honest signal — it flips when the response lands, so
  // this now means "we have not heard back yet", which is the only time a
  // skeleton is the right thing to show. Once the answer arrives it is either
  // posts or the empty state, and never both.
  const showFeedSkeleton = useDelayedFlag(!isDataFeteched && posts.length === 0);

  const refreshFunction = async () => {
    try {
      await fetchPost();
    } catch (error) {
      console.error("Error refreshing feed:", error);
    }
  };

  const { containerProps, isRefreshing, pullDistance } = usePullToRefresh({
    onRefresh: refreshFunction,
    disabled: false,
  });

  return (
    <>
      {/* Hidden file input for desktop comment image upload */}
      <input
        type="file"
        ref={commentImageInputRef}
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const allowedTypes = [
              "image/jpeg",
              "image/png",
              "image/webp",
              "image/jpg",
              "image/gif",
            ];
            if (!allowedTypes.includes(file.type)) {
              toast.error("Choose a JPG, PNG, WEBP, or GIF image.");
              e.target.value = "";
              return;
            }
            if (file.size > 5 * 1024 * 1024) {
              toast.error("Image must be under 5 MB.");
              e.target.value = "";
              return;
            }
            setCommentImage(file);
            setCommentImagePreview(URL.createObjectURL(file));
          }
          e.target.value = "";
        }}
      />
      {!embedded && (
        <DashboardHeader
          toggle={sidebarToggle}
          avatar={profile?.image}
          user={{ name: profile?.full_name }}
          setStocksData={setPosts}
          setLoader={setLoader}
          onFeedSearch={() => setFeedSearchActive((v) => !v)}
          feedSearchActive={feedSearchActive}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
          {...(game && { game })}
        />
      )}

      <Shell {...shellProps}>
        {!embedded && game_id && <GameSideBar activeMenu="feeds" slug={slug} />}
        <div {...containerProps}>
          {/* The league's own Home carries these actions in its tab bar and rail,
              so they'd be duplicates there. */}
          {!embedded && game_id && !isMobileView && (
            <button
              className="float-right px-3 h-[40px] rounded-[5px] py-1 mx-2 text-sm border-none cursor-pointer bg-primaryColor text-white"
              onClick={() => navigate(`/${slug}/create-feed`)}
            >
              Add Post
            </button>
          )}
          {!embedded && game_id && isMobileView && (
            <div className="grid grid-cols-2 gap-5">
              <button
                className="justify-center px-6 h-10 rounded-[5px] py-2  text-sm border-none cursor-pointer flex gap-2.5 items-center bg-primaryColor text-white"
                onClick={handleExitGame}
              >
                {IconExit} Exit League
              </button>

              <button
                className="justify-center px-6 h-10 rounded-[5px] py-2  text-sm border-none cursor-pointer flex gap-2.5 items-center bg-primaryColor text-white"
                onClick={gameLeaderboard}
              >
                Leadeboard
              </button>
            </div>
          )}
          <div className="md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
            {/* Client Rev 2, desktop League Home: "Feed post container cards need
                to be the same width as the composer card. Increase feed post width
                to match."
                Measured at 1440px BEFORE: the composer ran 288..1058 (770px) while
                a post card ran 312..1034 (722px) — 48px narrower and 24px further
                right, because this wrapper adds md:px-4 (16 a side) and md:mx-2 (8
                a side) on top of the column both share. Inside a league those four
                gutters come off, so a post card lands on the composer's exact
                edges. The main QUSHi feed keeps them — it has no composer card
                beside it to line up with. */}
            <div
              className={`flex flex-col px-0 bg-white md:rounded-xl md:shadow-none py-2 ${
                embedded ? "" : "md:px-4 md:mx-2"
              }`}
            >
              {!game_id && (
                <div className="w-full flex flex-col items-center justify-center md:mt-24 mt-[72px]">
                 <div className={pullDistance > 0 || isRefreshing ? "mb-5 w-full" : "w-full"}>
                    <PullToRefreshIndicator pullDistance={pullDistance} isRefreshing={isRefreshing} />
                  </div>
                  <div className="w-full flex items-center justify-center">
                    {feedSearchActive ? (
                      <div className="w-full px-2 relative">
                        <input
                          type="text"
                          placeholder="Search..."
                          value={search}
                          onChange={handleInputChange}
                          autoFocus
                          className="border border-grey-400 rounded-full text-sm w-full px-4 py-2.5 pr-10 focus:outline-none focus:border-green-300 bg-slate-50"
                        />
                        <FontAwesomeIcon
                          className="absolute right-6 top-1/2 -translate-y-1/2 text-slate-500"
                          icon={faMagnifyingGlass}
                        />
                      </div>
                    ) : (
                      <FeedTop />
                    )}
                  </div>
                </div>
              )}
              {/* The league's own Home puts the feed straight under its heading —
                  no search bar between the two. Only the legacy /:slug/feeds
                  screen still carries one. */}
              {!embedded && game_id && isMobileView && (
                <div className="px-2 mt-1 mb-2">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={handleInputChange}
                    className={`border border-grey-400 rounded-full text-sm w-full px-3 py-2 focus:outline-none focus:border-green-300 bg-slate-50 ${
                      isMobileView ? "mt-4" : "md:w-[230px]"
                    }`}
                  />
                  <FontAwesomeIcon
                    className={"-ml-7 mt-6 text-slate-500"}
                    icon={faMagnifyingGlass}
                  ></FontAwesomeIcon>
                </div>
              )}
              {!game_id && posts.length > 0 && (
                <div
                  className={`mt-3 min-h-px bg-gray-300 md:hidden ${
                    isMobileView && "-mx-2 w-[calc(100%+1rem)]"
                  }`}
                ></div>
              )}
              {/* Client Rev 3, 2: "every time I leave League Home and return, the
                  empty state message flashes briefly before the existing posts
                  appear. Can we prevent the empty state from displaying while
                  the posts are loading?"
                  On every remount `posts` starts as [] and the request resolves a
                  moment later, so there was a window where this block rendered —
                  and the skeleton could not cover it, because useDelayedFlag
                  deliberately holds the skeleton back so a fast load never
                  flashes one. The empty state now waits until the feed has
                  actually answered.
                  The gate is `isDataFeteched`, NOT the `loading` flag: `loading`
                  is initialised true and is only ever cleared by the like and
                  delete-comment handlers — the post fetch never touches it — so
                  gating on it would have hidden the empty state permanently on a
                  league that really has no posts. `setisDataFeteched(true)` is
                  what fetchPost sets when the response lands, which is exactly
                  the "we have looked, and there is nothing" signal this needs. */}
              {isDataFeteched &&
                posts.filter((post) => post.game_id === game_id).length === 0 &&
                game_id && (
                  /* Client Rev 2, desktop Private League Home 10: "Change
                     No Posts Yet!!. Empty state for both public and private
                     league home screen feeds." Two states, because the organiser
                     and a member are being asked for different things — the
                     organiser sets the tone, a member joins a conversation that
                     has not started. Both CTAs open the league composer, which is
                     the same modal the collapsed composer row opens. */
                  <div className="w-full mt-3 px-4 py-10 text-center">
                    <p className="font-montserrat font-bold text-base text-[#1A1A1A]">
                      {isLeagueOrganizer
                        ? "Start the conversation"
                        : "No posts yet"}
                    </p>
                    <p className="mt-1 text-sm text-secondary">
                      {isLeagueOrganizer
                        ? "Welcome your group, set the tone, or share the first trade idea."
                        : "Be the first to get the conversation started."}
                    </p>
                    {onCompose && (
                      <button
                        type="button"
                        onClick={onCompose}
                        className="mt-4 rounded-xl bg-[#0F4146] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#0B3A3F]"
                      >
                        {isLeagueOrganizer
                          ? "Create first post"
                          : "Create a post"}
                      </button>
                    )}
                  </div>
                )}
              {/* Full width line separator */}
              <div
                className={`bg-white ${
                  isMobileView && "-mx-2 w-[calc(100%+1rem)]"
                }`}
              >
                <main className="h-full bg-#fbfcfc justify-center">
                  {/* Initial feed load: post-card skeletons. Previously the feed
                      rendered nothing at all until the first page arrived. Only
                      shown while there is genuinely nothing on screen, so a
                      refresh never replaces real posts. */}
                  {showFeedSkeleton && <PostListSkeleton posts={3} />}
                  <InfiniteScroll
                    dataLength={posts.length}
                    next={posts.length > 9 && fetchMorePost}
                    hasMore={!postId && hasMore}
                    loader={loader && <PostListSkeleton posts={1} />}
                    style={{
                      overflow: "hidden",
                      marginInline: isMobileView ? 0 : -16,
                    }}
                    endMessage={
                      !postId && (
                        <p style={{ textAlign: "center" }}>
                          <b>Yay! You have seen it all</b>
                        </p>
                      )
                    }
                  >
                    {/* {!game_id && (
  <> */}
                    {/* 4      */}
                    <div id="feed-guide-feed" className="sm:p-4">
                      {posts.length > 0
                        ? posts
                            .filter((post) => {
                              if (!game_id) {
                                return !post?.game_id; // Include posts without game_id if game_id is not set
                              }
                              return post?.game_id === game_id; // Include posts matching game_id
                            })
                            .map((post, index) => {
                              return (
                                <React.Fragment key={`feed-item-${index}`}>
                                  {isMobileView ? (
                                    <>
                                      {/* <FeedCard feedData={post} handleLikeDislike={handleLikeDislike} handleShare={handleShare} index={index}/> */}
                                      <div
                                        className="w-full bg-white border-b border-[#D7DADF] pb-4"
                                        key={index}
                                        id={
                                          post?.repost?.id
                                            ? post?.repost?.id
                                            : post?.id
                                        }
                                      >
                                        <div className="py-3.5 px-[18px] flex items-center justify-between gap-2 ">
                                          <div className="flex items-center gap-2">
                                            {post?.repost?.id &&
                                            loginUserId !=
                                              post?.repost?.user?.id ? (
                                              <Link
                                                to={profilePath(
                                                  post?.repost?.user?.id,
                                                )}
                                                className={
                                                  isMobileView ? "w-10" : ""
                                                }
                                              >
                                                <img
                                                  src={
                                                    post?.repost?.id
                                                      ? post?.repost?.user
                                                          ?.image
                                                      : post?.user?.image
                                                  }
                                                  alt="profile"
                                                  /* Client Rev 2, League Home/Feed 3:
                                               "Reduce member profile picture size on
                                               feed posts. Current avatars are too
                                               visually dominant relative to the post
                                               content." The league feed had a 40px
                                               avatar where the main feed uses 32px;
                                               a post has no reason to look different
                                               inside a league, so the branch is gone. */
                                                  className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                />
                                              </Link>
                                            ) : post?.repost?.user?.id ==
                                              loginUserId ? (
                                              <Link
                                                to={profilePath()}
                                                className={
                                                  isMobileView ? "w-10" : ""
                                                }
                                              >
                                                <img
                                                  src={
                                                    post?.repost?.id
                                                      ? post?.repost?.user
                                                          ?.image
                                                      : post?.user?.image
                                                  }
                                                  alt="profile"
                                                  /* Client Rev 2, League Home/Feed 3:
                                               "Reduce member profile picture size on
                                               feed posts. Current avatars are too
                                               visually dominant relative to the post
                                               content." The league feed had a 40px
                                               avatar where the main feed uses 32px;
                                               a post has no reason to look different
                                               inside a league, so the branch is gone. */
                                                  className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                />
                                              </Link>
                                            ) : loginUserId ==
                                              post?.user?.id ? (
                                              <Link
                                                to={profilePath()}
                                                className={
                                                  isMobileView ? "w-10" : ""
                                                }
                                              >
                                                <img
                                                  src={
                                                    post?.repost?.id
                                                      ? post?.repost?.user
                                                          ?.image
                                                      : post?.user?.image
                                                  }
                                                  alt="profile"
                                                  /* Client Rev 2, League Home/Feed 3:
                                               "Reduce member profile picture size on
                                               feed posts. Current avatars are too
                                               visually dominant relative to the post
                                               content." The league feed had a 40px
                                               avatar where the main feed uses 32px;
                                               a post has no reason to look different
                                               inside a league, so the branch is gone. */
                                                  className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                />
                                              </Link>
                                            ) : (
                                              <Link
                                                to={profilePath(post?.user?.id)}
                                                className={
                                                  isMobileView ? "w-10" : ""
                                                }
                                              >
                                                <img
                                                  src={
                                                    post?.repost?.id
                                                      ? post?.repost?.user
                                                          ?.image
                                                      : post?.user?.image
                                                  }
                                                  alt="profile"
                                                  /* Client Rev 2, League Home/Feed 3:
                                               "Reduce member profile picture size on
                                               feed posts. Current avatars are too
                                               visually dominant relative to the post
                                               content." The league feed had a 40px
                                               avatar where the main feed uses 32px;
                                               a post has no reason to look different
                                               inside a league, so the branch is gone. */
                                                  className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                />
                                              </Link>
                                            )}

                                            <div>
                                              <span className="text-[15px] font-semibold block leading-tight">
                                                {/* Client Rev 2, global League Play rule
                                              5: "Remove @ before usernames
                                              everywhere inside League Play. I see
                                              it on the feed when i post."
                                              An earlier round added the prefix only
                                              in `embedded` (league) mode, reasoning
                                              that a league feed reads as a room
                                              full of handles. The client has ruled
                                              the other way, so the league feed now
                                              prints the same bare handle the main
                                              feed does. */}
                                                {(post?.repost?.id
                                                  ? post?.repost?.user
                                                      ?.user_name
                                                  : post?.user?.user_name)?.replace(/^@/, "")}
                                                {post?.user?.green_tick && (
                                                  <img
                                                    src={GreenTick}
                                                    alt="green-tick object-cover"
                                                    className="ml-1 "
                                                  />
                                                )}
                                              </span>
                                              {/* When the post was made. The main feed
                                            carries this further down the card. */}
                                              {embedded && (
                                                <span className="text-[11px] font-medium text-[#888888] block">
                                                  {calculateTimeAgo(
                                                    post?.repost?.id
                                                      ? post?.repost?.created_at
                                                      : post.created_at,
                                                  )}
                                                </span>
                                              )}
                                              {post?.repost?.id && (
                                                <span className="text-[11px] font-medium text-[#888888] block">
                                                  {post?.user?.user_name?.replace(/^@/, "")}{" "}
                                                  Reposted
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          <div className="flex items-center justify-between ">
                                            <div>
                                              {/* <span
                                                        className={
                                                          isMobileView
                                                            ? "mr-1 text-base  text-gray-600 font-poppins truncate"
                                                            : "mr-4 text-base  text-gray-600 font-poppins truncate"
                                                        }
                                                      >
                                                        {calculateTimeAgo(
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post.created_at
                                                        )}
                                                      </span> */}
                                            </div>
                                            {game_id && (
                                              <div>
                                                <span
                                                  className={
                                                    isMobileView
                                                      ? "mr-1 text-base text-gray-600 font-poppins truncate"
                                                      : "mr-4 text-base text-gray-600 font-poppins truncate"
                                                  }
                                                >
                                                  {post.user_id ===
                                                    profile.id && (
                                                    <div className="relative inline-block text-left">
                                                      <button
                                                        data-post-menu
 onClick={() =>
                                                          toggleDropdown(post.id)
                                                        }
                                                        type="button"
                                                        className={
                                                          isMobileView
                                                            ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                            : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={
                                                            isMobileView
                                                              ? faEllipsisV
                                                              : faEllipsisH
                                                          }
                                                        />
                                                      </button>
                                                      {openMenuPostId === post.id && (
                                                        <div data-post-menu onClick={() => setOpenMenuPostId(null)} className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                          <button
                                                            className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                            role="menuitem"
                                                            onClick={() =>
                                                              handleDeletePost(
                                                                post.id,
                                                              )
                                                            }
                                                          >
                                                            <div className="flex flex-row justify-center items-center">
                                                              <FontAwesomeIcon
                                                                icon={faTrash}
                                                              />
                                                              <p className="ml-[0.60rem]">
                                                                Delete
                                                              </p>
                                                            </div>
                                                          </button>
                                                          <button
                                                            onClick={() =>
                                                              handleEditClick(
                                                                post?.repost?.id
                                                                  ? post?.repost
                                                                      ?.id
                                                                  : post.id,
                                                              )
                                                            }
                                                            className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                            role="menuitem"
                                                          >
                                                            <div className="flex flex-row justify-center items-center">
                                                              <FontAwesomeIcon
                                                                icon={faEdit}
                                                              />
                                                              <p className="ml-[0.60rem]">
                                                                Edit
                                                              </p>
                                                            </div>
                                                          </button>
                                                        </div>
                                                      )}
                                                    </div>
                                                  )}
                                                </span>
                                              </div>
                                            )}

                                            {post?.user?.id === profile.id ? (
                                              ""
                                            ) : (
                                              <div
                                                className={
                                                  isMobileView
                                                    ? "relative inline-block text-left"
                                                    : "relative inline-block mr-2 text-left"
                                                }
                                              >
                                                <span
                                                  data-post-menu
 onClick={() =>
                                                    toggleDropdown(post.id)
                                                  }
                                                  type="button"
                                                  className="cursor-pointer"
                                                >
                                                  {TheDotsIcon}
                                                </span>
                                                {openMenuPostId === post.id && (
                                                  <div data-post-menu onClick={() => setOpenMenuPostId(null)} className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                    <button
                                                      className="block text-primaryColor w-full  px-2 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                      onClick={() =>
                                                        handleBlock(
                                                          post?.repost?.id
                                                            ? post?.repost?.user
                                                                ?.id
                                                            : post?.user?.id,
                                                          "block",
                                                        )
                                                      }
                                                    >
                                                      <div className="flex  ml-2">
                                                        <FontAwesomeIcon
                                                          className="h-3 mt-1"
                                                          icon={faBan}
                                                        />{" "}
                                                        <p className="ml-[0.60rem]">
                                                          Block User
                                                        </p>
                                                      </div>
                                                    </button>
                                                    <button
                                                      className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                      onClick={() =>
                                                        handleReport(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          "report",
                                                        )
                                                      }
                                                    >
                                                      <div className="flex ml-2">
                                                        <FontAwesomeIcon
                                                          className="h-3 mt-1"
                                                          icon={faFlag}
                                                        />{" "}
                                                        <p className="ml-2">
                                                          Report Post
                                                        </p>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {post.post_image?.length > 0 ||
                                        post?.repost?.post_image?.length > 0 ? (
                                          post?.repost?.id ? (
                                            post?.repost?.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];

                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="p-0 pswp-gallery"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0],
                                                    ) ? (
                                                      <div
                                                        className="relative"
                                                        onClick={() =>
                                                          togglePlay(post.id)
                                                        }
                                                      >
                                                        {isLoading[post.id] && (
                                                          <div
                                                            className="absolute inset-0 bg-[#f8f8f8]"
                                                            aria-busy="true"
                                                            aria-label="Video loading"
                                                          >
                                                            <SkeletonBlock
                                                              width="100%"
                                                              height="100%"
                                                              rounded="rounded"
                                                            />
                                                          </div>
                                                        )}

                                                        {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                      className="w-full"
                                                    /> */}
                                                        {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                        {/* </div>
                                                  ) : ( */}
                                                        {/* Mobile video edited 1*/}
                                                        {/* <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      poster={image.thumb}
                                                      autoPlay
                                                      playsInline
                                                      controls="false"
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video> */}
                                                        {/* <video
                                                                  ref={setVideoRef}
                                                                  poster={image.thumb}
                                                                  autoPlay
                                                                  playsInline
                                                                  loop
                                                                  controls={false}
                                                                  className="w-full max-h-full object-contain"
                                                                  onClick={(e) => {
                                                                    handleVideoPlayPause(e.target); // Pause or resume the video
                                                                    handleVideoClick(index, imageIndex); // Handle custom click event
                                                                  }}
                                                                >
                                                                  <source src={image.image} />
                                                                </video> */}

                                                        {pausedVideoId ===
                                                          post.id && (
                                                          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                            <FontAwesomeIcon
                                                              icon={faPlay}
                                                              className="text-green-500 text-3xl opacity-60"
                                                            />
                                                          </div>
                                                        )}

                                                        <video
                                                          id={post.id}
                                                          ref={(el) =>
                                                            (videosRef.current[
                                                              post.id
                                                            ] = el)
                                                          }
                                                          poster={image.thumb}
                                                          src={image.image}
                                                          className="w-full max-h-full object-contain"
                                                          onMouseEnter={() =>
                                                            handleVisibility(
                                                              post.id,
                                                              true,
                                                            )
                                                          }
                                                          onMouseLeave={() =>
                                                            handleVisibility(
                                                              post.id,
                                                              false,
                                                            )
                                                          }
                                                          onClick={() =>
                                                            togglePlay(post.id)
                                                          }
                                                          loop
                                                          playsInline
                                                          webkit-playsinline="true"
                                                          x5-playsinline="true"
                                                          x-webkit-airplay="deny"
                                                          disablePictureInPicture={
                                                            true
                                                          }
                                                          preload="auto"
                                                          autoPlay // ✅ Autoplay enabled
                                                          muted={isMuted} // ✅ Controlled mute state
                                                          onLoadedMetadata={(
                                                            e,
                                                          ) => {
                                                            e.target.setAttribute(
                                                              "playsinline",
                                                              "true",
                                                            ); // ✅ Force playsInline for iOS
                                                            e.target.setAttribute(
                                                              "muted",
                                                              "true",
                                                            ); // ✅ Ensure it's muted
                                                            e.target
                                                              .play()
                                                              .catch((err) =>
                                                                console.warn(
                                                                  "Autoplay blocked",
                                                                  err,
                                                                ),
                                                              );
                                                            handleVideoCanPlay(
                                                              post.id,
                                                            ); // ✅ Call earlier
                                                          }}
                                                          // onCanPlay={(e) => {
                                                          //   console.log(`Video ${post.id} can play now`);
                                                          //   e.target.play(); // ✅ Force play
                                                          //   handleVideoCanPlay(post.id);
                                                          // }}
                                                          onLoadedData={() =>
                                                            handleVideoCanPlay(
                                                              post.id,
                                                            )
                                                          }
                                                          // onPlay={() => setIsLoading(false)}
                                                        />

                                                        {/* Mute button positioned inside the post at the bottom-right corner */}
                                                        <button
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // Prevent click from bubbling to parent
                                                            toggleMute();
                                                          }}
                                                          className="absolute bottom-4 right-4 px-4 py-2 text-sm"
                                                        >
                                                          {isMuted
                                                            ? "🔇"
                                                            : "🔊"}
                                                        </button>

                                                        {/* )} */}
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            className="w-full"
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index,
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              },
                                            )
                                          ) : (
                                            post.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];

                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="p-0 pswp-gallery"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0],
                                                    ) ? (
                                                      <div
                                                        className="relative"
                                                        onClick={() =>
                                                          togglePlay(post.id)
                                                        }
                                                      >
                                                        {isLoading[post.id] && (
                                                          <div
                                                            className="absolute inset-0 bg-[#f8f8f8]"
                                                            aria-busy="true"
                                                            aria-label="Video loading"
                                                          >
                                                            <SkeletonBlock
                                                              width="100%"
                                                              height="100%"
                                                              rounded="rounded"
                                                            />
                                                          </div>
                                                        )}

                                                        {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      className={"w-full"}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                    /> */}
                                                        {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                        {/* </div>
                                                  ) : ( */}
                                                        {/* mobile view edited 2 */}
                                                        {/* <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      poster={image.thumb}
                                                      autoPlay
                                                      playsInline
                                                      controls="false"
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video> */}

                                                        {pausedVideoId ===
                                                          post.id && (
                                                          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                            <FontAwesomeIcon
                                                              icon={faPlay}
                                                              className="text-green-500 text-3xl opacity-60"
                                                            />
                                                          </div>
                                                        )}

                                                        <video
                                                          id={post.id}
                                                          ref={(el) =>
                                                            (videosRef.current[
                                                              post.id
                                                            ] = el)
                                                          }
                                                          poster={image.thumb}
                                                          src={image.image}
                                                          className="w-full max-h-full object-contain"
                                                          onMouseEnter={() =>
                                                            handleVisibility(
                                                              post.id,
                                                              true,
                                                            )
                                                          }
                                                          onMouseLeave={() =>
                                                            handleVisibility(
                                                              post.id,
                                                              false,
                                                            )
                                                          }
                                                          onClick={() =>
                                                            togglePlay(post.id)
                                                          }
                                                          loop
                                                          playsInline
                                                          webkit-playsinline="true"
                                                          x5-playsinline="true"
                                                          x-webkit-airplay="deny"
                                                          disablePictureInPicture={
                                                            true
                                                          }
                                                          preload="auto"
                                                          autoPlay // ✅ Autoplay enabled
                                                          muted={isMuted} // ✅ Controlled mute state
                                                          onLoadedMetadata={(
                                                            e,
                                                          ) => {
                                                            e.target.setAttribute(
                                                              "playsinline",
                                                              "true",
                                                            ); // ✅ Force playsInline for iOS
                                                            e.target.setAttribute(
                                                              "muted",
                                                              "true",
                                                            ); // ✅ Ensure it's muted
                                                            e.target
                                                              .play()
                                                              .catch((err) =>
                                                                console.warn(
                                                                  "Autoplay blocked",
                                                                  err,
                                                                ),
                                                              );
                                                            handleVideoCanPlay(
                                                              post.id,
                                                            ); // ✅ Call earlier
                                                          }}
                                                          // onCanPlay={(e) => {
                                                          //   console.log(`Video ${post.id} can play now`);
                                                          //   e.target.play(); // ✅ Force play
                                                          //   handleVideoCanPlay(post.id);
                                                          // }}
                                                          onLoadedData={() =>
                                                            handleVideoCanPlay(
                                                              post.id,
                                                            )
                                                          }
                                                          // onPlay={() => setIsLoading(false)}
                                                        />

                                                        {/* Mute button positioned inside the post at the bottom-right corner */}
                                                        <button
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // Prevent click from bubbling to parent
                                                            toggleMute();
                                                          }}
                                                          className="absolute bottom-4 right-4 px-4 py-2 text-sm"
                                                        >
                                                          {isMuted
                                                            ? "🔇"
                                                            : "🔊"}
                                                        </button>

                                                        {/* )} */}
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            className="w-full"
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index,
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              },
                                            )
                                          )
                                        ) : (
                                          <div className="py-3.5 px-[18px]  bg-white">
                                            <p className="text-base  font-medium whitespace-pre-line text-black">
                                              {" "}
                                              {post?.repost?.id ? (
                                                <>
                                                  <PostCaption
                                                    description={
                                                      post?.description
                                                    }
                                                    hideUrl={
                                                      !!linkPreviewData[
                                                        post?.repost?.id ||
                                                          post.id
                                                      ]
                                                    }
                                                    expanded={
                                                      !!showFullDescription[
                                                        index
                                                      ]
                                                    }
                                                    onToggle={() =>
                                                      setShowFullDescription(
                                                        (prevState) => {
                                                          const newState = [
                                                            ...prevState,
                                                          ];
                                                          newState[index] =
                                                            !newState[index];
                                                          return newState;
                                                        },
                                                      )
                                                    }
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  <PostCaption
                                                    description={
                                                      post?.description
                                                    }
                                                    hideUrl={
                                                      !!linkPreviewData[
                                                        post?.repost?.id ||
                                                          post.id
                                                      ]
                                                    }
                                                    expanded={
                                                      !!showFullDescription[
                                                        index
                                                      ]
                                                    }
                                                    onToggle={() =>
                                                      setShowFullDescription(
                                                        (prevState) => {
                                                          const newState = [
                                                            ...prevState,
                                                          ];
                                                          newState[index] =
                                                            !newState[index];
                                                          return newState;
                                                        },
                                                      )
                                                    }
                                                  />
                                                </>
                                              )}
                                            </p>
                                            {linkPreviewData[
                                              post?.repost?.id || post.id
                                            ] && (
                                              <div className="px-[18px] pb-3">
                                                <LinkPreviewCard
                                                  url={
                                                    linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ].url
                                                  }
                                                  title={
                                                    linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ].title
                                                  }
                                                  description={
                                                    linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ].description
                                                  }
                                                  image={
                                                    linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ].image
                                                  }
                                                  site_name={
                                                    linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ].site_name
                                                  }
                                                  loading={
                                                    !!linkPreviewData[
                                                      post?.repost?.id ||
                                                        post.id
                                                    ]._loading
                                                  }
                                                />
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        <div className="p-4 space-y-2">
                                          <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-4">
                                              <button
                                                onClick={() =>
                                                  handleLikeDislike(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                    post.total_likes,
                                                  )
                                                }
                                                className="flex flex-row justify-center items-center"
                                              >
                                                {post?.repost?.id
                                                  ? post?.repost?.is_like_by_me
                                                    ? HeartFilledIcon
                                                    : HeartIcon
                                                  : post?.is_like_by_me
                                                    ? HeartFilledIcon
                                                    : HeartIcon}

                                                <p className="ml-1 md:text-xs text-base">
                                                  {post?.repost?.id
                                                    ? post?.repost?.total_likes
                                                    : post.total_likes}
                                                </p>
                                              </button>

                                              <button
                                                onClick={() =>
                                                  handleCommentToggle(
                                                    index,
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                  )
                                                }
                                                className="flex flex-row justify-center items-center"
                                              >
                                                {CommentIcon}
                                                <p className="ml-1 md:text-xs text-base">
                                                  {post?.repost?.id
                                                    ? post?.repost
                                                        ?.total_comments
                                                    : post.total_comments}
                                                </p>
                                              </button>

                                              <button
                                                onClick={() =>
                                                  handleShare(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                  )
                                                }
                                              >
                                                {ShareIcon}
                                              </button>
                                              {/* <button>{RepostIcon}</button> */}

                                              <button
                                                disabled={
                                                  isDisabled ? true : false
                                                }
                                                onClick={() =>
                                                  handleRepost(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                    post?.repost?.id
                                                      ? post.user_id
                                                      : "",
                                                    post.id,
                                                  )
                                                }
                                                className="flex flex-row justify-center items-center "
                                              >
                                                {RepostIcon}
                                                <p className="ml-1 md:text-xs text-base">
                                                  {post?.repost?.id
                                                    ? post?.repost?.repost_count
                                                    : post.repost_count}
                                                </p>
                                              </button>
                                            </div>
                                            {/* <button>{SaveIcon}</button> */}

                                            <button
                                              disabled={
                                                isDisabled ? true : false
                                              }
                                              onClick={() =>
                                                handleSavePost(
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                )
                                              }
                                            >
                                              {post?.repost?.id ? (
                                                post?.repost?.is_saved ? (
                                                  <>{SaveIconFill}</>
                                                ) : (
                                                  <>{SaveIcon}</>
                                                )
                                              ) : post.is_saved ? (
                                                <>{SaveIconFill}</>
                                              ) : (
                                                <> {SaveIcon}</>
                                              )}
                                            </button>
                                          </div>
                                          <p>
                                            <span className="text-sm font-semibold">
                                              {/* {post?.repost?.id
                                          ? post?.repost?.total_likes
                                          : post.total_likes}{" "}
                                        likes */}
                                              {post?.user?.user_name?.replace(/^@/, "")}
                                            </span>{" "}
                                            <span className="text-[#888888] px-2">
                                              ·
                                            </span>
                                            <span className="text-[#888888] text-[12px] font-semibold">
                                              {calculateTimeAgo(
                                                post?.repost?.id
                                                  ? post?.repost?.created_at
                                                  : post.created_at,
                                              )}
                                            </span>
                                          </p>
                                          {post.post_image?.length > 0 && (
                                            <p className="text-base font-medium whitespace-pre-line">
                                              {" "}
                                              {post?.repost?.id ? (
                                                <>
                                                  <PostCaption
                                                    description={
                                                      post?.description
                                                    }
                                                    hideUrl={
                                                      !!linkPreviewData[
                                                        post?.repost?.id ||
                                                          post.id
                                                      ]
                                                    }
                                                    expanded={
                                                      !!showFullDescription[
                                                        index
                                                      ]
                                                    }
                                                    onToggle={() =>
                                                      setShowFullDescription(
                                                        (prevState) => {
                                                          const newState = [
                                                            ...prevState,
                                                          ];
                                                          newState[index] =
                                                            !newState[index];
                                                          return newState;
                                                        },
                                                      )
                                                    }
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  <PostCaption
                                                    description={
                                                      post?.description
                                                    }
                                                    hideUrl={
                                                      !!linkPreviewData[
                                                        post?.repost?.id ||
                                                          post.id
                                                      ]
                                                    }
                                                    expanded={
                                                      !!showFullDescription[
                                                        index
                                                      ]
                                                    }
                                                    onToggle={() =>
                                                      setShowFullDescription(
                                                        (prevState) => {
                                                          const newState = [
                                                            ...prevState,
                                                          ];
                                                          newState[index] =
                                                            !newState[index];
                                                          return newState;
                                                        },
                                                      )
                                                    }
                                                  />
                                                </>
                                              )}
                                            </p>
                                          )}
                                          {post.post_image?.length > 0 &&
                                            linkPreviewData[
                                              post?.repost?.id || post.id
                                            ] && (
                                              <LinkPreviewCard
                                                url={
                                                  linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ].url
                                                }
                                                title={
                                                  linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ].title
                                                }
                                                description={
                                                  linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ].description
                                                }
                                                image={
                                                  linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ].image
                                                }
                                                site_name={
                                                  linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ].site_name
                                                }
                                                loading={
                                                  !!linkPreviewData[
                                                    post?.repost?.id || post.id
                                                  ]._loading
                                                }
                                              />
                                            )}
                                          {commentOpenStates[index] && (
                                            <div className="mt-4 text-black  md:ml-[60px] lg:ml-[60px]">
                                              <div className="mt-4 space-y-4">
                                                {!loadingComment &&
                                                postComments[
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id
                                                ] &&
                                                postComments[
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id
                                                ].length > 0 ? (
                                                  postComments[
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id
                                                  ].map((comment) => (
                                                    <div
                                                      key={comment.id}
                                                      className="flex items-start mb-2"
                                                    >
                                                      <div className="flex-shrink-0">
                                                        <img
                                                          src={
                                                            comment?.user?.image
                                                          }
                                                          alt={`${comment?.user?.user_name}'s avatar`}
                                                          className="w-10 h-10 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                          onClick={(e) =>
                                                            navigateToUserProfile(
                                                              e,
                                                              comment?.user?.id,
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                      <div className="w-full">
                                                        <div className="flex justify-between mb-1">
                                                          <span
                                                            className="font-semibold ml-2 cursor-pointer hover:underline"
                                                            onClick={(e) =>
                                                              navigateToUserProfile(
                                                                e,
                                                                comment?.user
                                                                  ?.id,
                                                              )
                                                            }
                                                          >
                                                            {
                                                              comment?.user
                                                                ?.user_name?.replace(/^@/, "")
                                                            }
                                                          </span>
                                                          {comment?.user.id ===
                                                            profile?.id && (
                                                            <button
                                                              disabled={
                                                                isDisabled
                                                                  ? true
                                                                  : false
                                                              }
                                                              className="px-5 text-green-500 "
                                                              onClick={() =>
                                                                handleDeleteComment(
                                                                  comment.id,
                                                                )
                                                              }
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faTrash}
                                                              />
                                                            </button>
                                                          )}
                                                        </div>
                                                        <div className="flex justify-between">
                                                          <div
                                                            className={
                                                              "md:w-full w-52 ml-2"
                                                            }
                                                          >
                                                            {comment?.comment && (
                                                              <p
                                                                className="w-full break-words text-lg"
                                                                style={{
                                                                  whiteSpace:
                                                                    "pre-wrap",
                                                                  wordBreak:
                                                                    "break-word",
                                                                }}
                                                              >
                                                                {
                                                                  comment?.comment
                                                                }
                                                              </p>
                                                            )}
                                                            {comment?.image && (
                                                              <img
                                                                src={
                                                                  comment.image
                                                                }
                                                                alt="Comment image"
                                                                className="mt-1.5 rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                                                                loading="lazy"
                                                                onClick={() =>
                                                                  openCommentImage(
                                                                    comment.image,
                                                                  )
                                                                }
                                                              />
                                                            )}
                                                          </div>
                                                        </div>
                                                        {/* Reply button + View replies */}
                                                        <div className="flex items-center gap-3 ml-2 mt-1">
                                                          <button
                                                            className="text-xs text-gray-500 font-semibold hover:text-gray-700"
                                                            onClick={() =>
                                                              handleReply(
                                                                comment,
                                                                post?.repost?.id
                                                                  ? post?.repost
                                                                      ?.id
                                                                  : post.id,
                                                              )
                                                            }
                                                          >
                                                            Reply
                                                          </button>
                                                          {comment.replies_count >
                                                            0 && (
                                                            <button
                                                              className="text-xs text-blue-500 font-semibold hover:text-blue-700"
                                                              onClick={() =>
                                                                toggleReplies(
                                                                  comment.id,
                                                                )
                                                              }
                                                            >
                                                              {expandedReplies[
                                                                comment.id
                                                              ]
                                                                ? "Hide replies"
                                                                : `View ${comment.replies_count} ${comment.replies_count === 1 ? "reply" : "replies"}`}
                                                            </button>
                                                          )}
                                                        </div>
                                                        {/* Nested replies */}
                                                        {expandedReplies[
                                                          comment.id
                                                        ] &&
                                                          comment.replies
                                                            ?.length > 0 && (
                                                            <div className="ml-8 mt-2 space-y-3 border-l-2 border-gray-200 pl-3">
                                                              {comment.replies.map(
                                                                (reply) => (
                                                                  <div
                                                                    key={
                                                                      reply.id
                                                                    }
                                                                    className="flex items-start"
                                                                  >
                                                                    <div className="flex-shrink-0">
                                                                      <img
                                                                        src={
                                                                          reply
                                                                            ?.user
                                                                            ?.image
                                                                        }
                                                                        alt={`${reply?.user?.user_name}'s avatar`}
                                                                        className="w-7 h-7 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                                        onClick={(
                                                                          e,
                                                                        ) =>
                                                                          navigateToUserProfile(
                                                                            e,
                                                                            reply
                                                                              ?.user
                                                                              ?.id,
                                                                          )
                                                                        }
                                                                      />
                                                                    </div>
                                                                    <div className="flex-1">
                                                                      <div className="flex justify-between mb-0.5">
                                                                        <span
                                                                          className="font-semibold text-base ml-1 cursor-pointer hover:underline"
                                                                          onClick={(
                                                                            e,
                                                                          ) =>
                                                                            navigateToUserProfile(
                                                                              e,
                                                                              reply
                                                                                ?.user
                                                                                ?.id,
                                                                            )
                                                                          }
                                                                        >
                                                                          {
                                                                            reply
                                                                              ?.user
                                                                              ?.user_name?.replace(/^@/, "")
                                                                          }
                                                                        </span>
                                                                        {reply
                                                                          ?.user
                                                                          ?.id ===
                                                                          profile?.id && (
                                                                          <button
                                                                            disabled={
                                                                              isDisabled
                                                                            }
                                                                            className="px-3 text-green-500"
                                                                            onClick={() =>
                                                                              handleDeleteComment(
                                                                                reply.id,
                                                                              )
                                                                            }
                                                                          >
                                                                            <FontAwesomeIcon
                                                                              icon={
                                                                                faTrash
                                                                              }
                                                                            />
                                                                          </button>
                                                                        )}
                                                                      </div>
                                                                      {reply?.comment && (
                                                                        <p
                                                                          className="w-full break-words text-lg ml-1"
                                                                          style={{
                                                                            whiteSpace:
                                                                              "pre-wrap",
                                                                            wordBreak:
                                                                              "break-word",
                                                                          }}
                                                                        >
                                                                          {
                                                                            reply.comment
                                                                          }
                                                                        </p>
                                                                      )}
                                                                      {reply?.image && (
                                                                        <img
                                                                          src={
                                                                            reply.image
                                                                          }
                                                                          alt="Reply image"
                                                                          className="mt-1 rounded-lg max-w-[150px] max-h-[150px] object-cover cursor-pointer ml-1"
                                                                          loading="lazy"
                                                                          onClick={() =>
                                                                            openCommentImage(
                                                                              reply.image,
                                                                            )
                                                                          }
                                                                        />
                                                                      )}
                                                                      <button
                                                                        className="text-xs text-gray-500 font-semibold hover:text-gray-700 ml-1 mt-1"
                                                                        onClick={() =>
                                                                          handleReply(
                                                                            comment,
                                                                            post
                                                                              ?.repost
                                                                              ?.id
                                                                              ? post
                                                                                  ?.repost
                                                                                  ?.id
                                                                              : post.id,
                                                                          )
                                                                        }
                                                                      >
                                                                        Reply
                                                                      </button>
                                                                    </div>
                                                                  </div>
                                                                ),
                                                              )}
                                                            </div>
                                                          )}
                                                      </div>
                                                    </div>
                                                  ))
                                                ) : loadingComment ? (
                                                  <ListSkeleton
                                                    rows={2}
                                                    avatarSize={32}
                                                    columns={0}
                                                    divided={false}
                                                    rowClassName="py-3 px-4"
                                                  />
                                                ) : (
                                                  !loadingComment && (
                                                    <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                      <p>No comments yet</p>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                              <div
                                                className={`mt-4 relative ${
                                                  postId ? "mb-[60px]" : ""
                                                }`}
                                              >
                                                {replyingTo && (
                                                  <div className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-t mb-0">
                                                    <span className="text-sm text-gray-600">
                                                      Replying to{" "}
                                                      <span className="font-semibold">
                                                        @{replyingTo.userName?.replace(/^@/, "")}
                                                      </span>
                                                    </span>
                                                    <button
                                                      className="text-sm text-gray-500 hover:text-gray-700 font-semibold"
                                                      onClick={
                                                        handleCancelReply
                                                      }
                                                    >
                                                      Cancel
                                                    </button>
                                                  </div>
                                                )}
                                                {commentImagePreview && (
                                                  <div className="mb-2 relative inline-block">
                                                    <img
                                                      src={commentImagePreview}
                                                      alt="Preview"
                                                      className="h-20 w-20 object-cover rounded-lg border border-gray-200"
                                                    />
                                                    <button
                                                      className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                                                      onClick={() => {
                                                        setCommentImage(null);
                                                        setCommentImagePreview(
                                                          null,
                                                        );
                                                      }}
                                                    >
                                                      &times;
                                                    </button>
                                                  </div>
                                                )}
                                                <div className="flex">
                                                  <textarea
                                                    value={newComment}
                                                    onChange={(e) =>
                                                      setNewComment(
                                                        e.target.value,
                                                      )
                                                    }
                                                    placeholder="Add a comment..."
                                                    className="p-2 border border-emerald-500 rounded w-full text-black"
                                                    style={{
                                                      flex: 1,
                                                      resize: "none",
                                                      maxHeight: "150px",
                                                      overflowY: "auto",
                                                    }}
                                                    rows={4}
                                                  />

                                                  <div className="flex flex-col ml-2 gap-1">
                                                    <button
                                                      className="bg-gray-200 hover:bg-gray-300 text-gray-600 px-2 rounded-full focus:outline-none flex items-center justify-center"
                                                      onClick={() =>
                                                        commentImageInputRef.current?.click()
                                                      }
                                                      style={{
                                                        height: 30,
                                                        minWidth: 84,
                                                      }}
                                                    >
                                                      <svg
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="mr-1"
                                                      >
                                                        <rect
                                                          x="3"
                                                          y="3"
                                                          width="18"
                                                          height="18"
                                                          rx="2"
                                                          ry="2"
                                                        />
                                                        <circle
                                                          cx="8.5"
                                                          cy="8.5"
                                                          r="1.5"
                                                        />
                                                        <polyline points="21 15 16 10 5 21" />
                                                      </svg>
                                                      Image
                                                    </button>
                                                    <button
                                                      className="bg-primaryColor text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                                      disabled={
                                                        isDisabled ||
                                                        (!newComment.trim() &&
                                                          !commentImage)
                                                      }
                                                      onClick={() =>
                                                        handleAddComment(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          index,
                                                        )
                                                      }
                                                      style={{
                                                        height: 30,
                                                        minWidth: 84,
                                                      }}
                                                    >
                                                      Submit
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          {isModalOpen && newid === post.id && (
                                            <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
                                              <div className="bg-white p-6 rounded shadow-lg">
                                                {/* Modal content goes here */}
                                                <p>Delete this post? This can't be undone.</p>
                                                <button onClick={handleCloseModal} className="bg-gray-500 text-white py-2 px-4 rounded mt-4 mr-2">Cancel</button>
                                                <button onClick={handleDelete} className="bg-red-500 text-white py-2 px-4 rounded mt-4">Delete</button>
                                              </div>
                                            </div>
                                          )}
                                          {(post?.repost?.id
                                            ? post?.repost?.total_comments
                                            : post.total_comments) >= 1 && (
                                            <p
                                              onClick={() =>
                                                handleCommentToggle(
                                                  index,
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                )
                                              }
                                              className="cursor-pointer text-[#888888]"
                                            >
                                              View all{" "}
                                              <span>
                                                {post?.repost?.id
                                                  ? post?.repost?.total_comments
                                                  : post.total_comments}
                                              </span>{" "}
                                              comments
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      key={index}
                                      className="feed-shadow text-white pb-2 flex flex-col md:bg-white md:rounded-xl md:px-5 md:py-4 md:mb-5"
                                      id={
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post?.id
                                      }
                                    >
                                      {post?.repost?.id && (
                                        <div className="text-black">
                                          <div className="flex items-center mb-2 ml-0 md:ml-12">
                                            <FontAwesomeIcon
                                              className="text-primaryColor mr-2"
                                              icon={faRepeat}
                                            />
                                            <p
                                              className="text-lg font-bold whitespace-nowrap"
                                              style={{ color: "#004c50" }}
                                            >
                                              {post?.user?.user_name?.replace(/^@/, "")} Reposted
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                          {post?.repost?.id &&
                                          loginUserId !=
                                            post?.repost?.user?.id ? (
                                            <Link
                                              to={profilePath(
                                                post?.repost?.user?.id,
                                              )}
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                alt="profile"
                                                className={`rounded-full ${
                                                  isMobileView
                                                    ? "h-10 w-full mr-0 object-cover"
                                                    : "h-10 w-10  mr-2  object-cover"
                                                }`}
                                              />
                                            </Link>
                                          ) : post?.repost?.user?.id ==
                                            loginUserId ? (
                                            <Link
                                              to={profilePath()}
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                alt="profile"
                                                className={`rounded-full ${
                                                  isMobileView
                                                    ? "h-10 w-full mr-0 object-cover"
                                                    : "h-10 w-10  mr-2  object-cover"
                                                }`}
                                              />
                                            </Link>
                                          ) : loginUserId == post?.user?.id ? (
                                            <Link
                                              to={profilePath()}
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                alt="profile"
                                                className={`rounded-full ${
                                                  isMobileView
                                                    ? "h-10 w-full mr-0 object-cover"
                                                    : "h-10 w-10  mr-2  object-cover"
                                                }`}
                                              />
                                            </Link>
                                          ) : (
                                            <Link
                                              to={profilePath(post?.user?.id)}
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                alt="profile"
                                                className={`rounded-full ${
                                                  isMobileView
                                                    ? "h-10 w-full mr-0 object-cover"
                                                    : "h-10 w-10  mr-2  object-cover"
                                                }`}
                                              />
                                            </Link>
                                          )}

                                          {/* <div>
                                  {post?.repost?.id &&
                                  loginUserId != post?.repost?.user?.id ? (
                                    <Link
                                      to={`/profile/${post?.repost?.user?.id}`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {(post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name)?.replace(/^@/, "")}
                                      </span>
                                    </Link>
                                  ) : post?.repost?.user?.id == loginUserId ? (
                                    <Link
                                      to={`/profile`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {(post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name)?.replace(/^@/, "")}
                                      </span>
                                    </Link>
                                  ) : loginUserId == post?.user?.id ? (
                                    <Link
                                      to={`/profile`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {(post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name)?.replace(/^@/, "")}
                                      </span>
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/profile/${post?.user?.id}`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                      </span>
                                    </Link>
                                  )}
                                </div> */}

                                          <span
                                            className={
                                              isMobileView
                                                ? "px-1 text-[19px] sm:ml-[0] text-auto text-black font-bold font-poppins truncate"
                                                : "px-1 sm:ml-[0]  text-[20px] text-black font-bold font-poppins truncate"
                                            }
                                          >
                                            {/* Client Rev 2, global League Play rule 5:
                                          "Remove @ before usernames everywhere
                                          inside League Play. I see it on the feed
                                          when i post."
                                          There are TWO post headers in this file —
                                          a compact one used higher up and this
                                          one. The earlier round stripped the @
                                          from the compact header only, so inside a
                                          league the prefix was still being printed
                                          here; it is visible in a league feed
                                          screenshot. `embedded` is true only inside
                                          League Play, so the main QUSHi feed keeps
                                          the @ it has always had. */}
                                            {(post?.repost?.id
                                              ? post?.repost?.user?.user_name
                                              : post?.user?.user_name)?.replace(/^@/, "")}
                                          </span>

                                          {post?.user?.green_tick ? (
                                            <img
                                              src={GreenTick}
                                              alt="green-tick object-cover"
                                              className="ml-1 "
                                            />
                                          ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                          null}
                                        </div>
                                        <div className="flex items-center justify-between ">
                                          <div>
                                            <span
                                              className={
                                                isMobileView
                                                  ? "mr-1 text-base  text-gray-600 font-poppins truncate"
                                                  : "mr-4 text-base  text-gray-600 font-poppins truncate"
                                              }
                                            >
                                              {calculateTimeAgo(
                                                post?.repost?.id
                                                  ? post?.repost?.created_at
                                                  : post.created_at,
                                              )}
                                            </span>
                                          </div>
                                          {game_id && (
                                            <div>
                                              <span
                                                className={
                                                  isMobileView
                                                    ? "mr-1 text-base text-gray-600 font-poppins truncate"
                                                    : "mr-4 text-base text-gray-600 font-poppins truncate"
                                                }
                                              >
                                                {post.user_id ===
                                                  profile.id && (
                                                  <div className="relative inline-block text-left">
                                                    <button
                                                      data-post-menu
 onClick={() =>
                                                        toggleDropdown(post.id)
                                                      }
                                                      type="button"
                                                      className={
                                                        isMobileView
                                                          ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                          : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={
                                                          isMobileView
                                                            ? faEllipsisV
                                                            : faEllipsisH
                                                        }
                                                      />
                                                    </button>
                                                    {openMenuPostId === post.id && (
                                                      <div data-post-menu onClick={() => setOpenMenuPostId(null)} className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                        <button
                                                          className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                          role="menuitem"
                                                          onClick={() =>
                                                            handleDeletePost(
                                                              post.id,
                                                            )
                                                          }
                                                        >
                                                          <div className="flex flex-row justify-center items-center">
                                                            <FontAwesomeIcon
                                                              icon={faTrash}
                                                            />
                                                            <p className="ml-[0.60rem]">
                                                              Delete
                                                            </p>
                                                          </div>
                                                        </button>
                                                        <button
                                                          onClick={() =>
                                                            handleEditClick(
                                                              post?.repost?.id
                                                                ? post?.repost
                                                                    ?.id
                                                                : post.id,
                                                            )
                                                          }
                                                          className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                          role="menuitem"
                                                        >
                                                          <div className="flex flex-row justify-center items-center">
                                                            <FontAwesomeIcon
                                                              icon={faEdit}
                                                            />
                                                            <p className="ml-[0.60rem]">
                                                              Edit
                                                            </p>
                                                          </div>
                                                        </button>
                                                      </div>
                                                    )}
                                                  </div>
                                                )}
                                              </span>
                                            </div>
                                          )}

                                          {post?.user?.id === profile.id ? (
                                            ""
                                          ) : (
                                            <div
                                              className={
                                                isMobileView
                                                  ? "relative inline-block text-left"
                                                  : "relative inline-block mr-2 text-left"
                                              }
                                            >
                                              <button
                                                data-post-menu
 onClick={() =>
                                                  toggleDropdown(post.id)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                    : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                />
                                              </button>
                                              {openMenuPostId === post.id && (
                                                <div data-post-menu onClick={() => setOpenMenuPostId(null)} className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                  <button
                                                    className="block text-primaryColor w-full  px-2 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                    onClick={() =>
                                                      handleBlock(
                                                        post?.repost?.id
                                                          ? post?.repost?.user
                                                              ?.id
                                                          : post?.user?.id,
                                                        "block",
                                                      )
                                                    }
                                                  >
                                                    <div className="flex  ml-2">
                                                      <FontAwesomeIcon
                                                        className="h-3 mt-1"
                                                        icon={faBan}
                                                      />{" "}
                                                      <p className="ml-[0.60rem]">
                                                        Block User
                                                      </p>
                                                    </div>
                                                  </button>
                                                  <button
                                                    className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                    onClick={() =>
                                                      handleReport(
                                                        post?.repost?.id
                                                          ? post?.repost?.id
                                                          : post.id,
                                                        "report",
                                                      )
                                                    }
                                                  >
                                                    <div className="flex ml-2">
                                                      <FontAwesomeIcon
                                                        className="h-3 mt-1"
                                                        icon={faFlag}
                                                      />{" "}
                                                      <p className="ml-2">
                                                        Report Post
                                                      </p>
                                                    </div>
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12  px-0 my-2 sm:px-10 font-poppins pswp-gallery"
                                            : "ml-6  px-0 my-2 sm:px-10 font-poppins pswp-gallery"
                                        }
                                      >
                                        {post?.repost?.id ? (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            <PostCaption
                                              description={post?.description}
                                              hideUrl={
                                                !!linkPreviewData[
                                                  post?.repost?.id || post.id
                                                ]
                                              }
                                              expanded={
                                                !!showFullDescription[index]
                                              }
                                              onToggle={() =>
                                                setShowFullDescription(
                                                  (prevState) => {
                                                    const newState = [
                                                      ...prevState,
                                                    ];
                                                    newState[index] =
                                                      !newState[index];
                                                    return newState;
                                                  },
                                                )
                                              }
                                            />
                                          </div>
                                        ) : (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            <PostCaption
                                              description={post?.description}
                                              hideUrl={
                                                !!linkPreviewData[
                                                  post?.repost?.id || post.id
                                                ]
                                              }
                                              expanded={
                                                !!showFullDescription[index]
                                              }
                                              onToggle={() =>
                                                setShowFullDescription(
                                                  (prevState) => {
                                                    const newState = [
                                                      ...prevState,
                                                    ];
                                                    newState[index] =
                                                      !newState[index];
                                                    return newState;
                                                  },
                                                )
                                              }
                                            />
                                          </div>
                                        )}
                                        {linkPreviewData[
                                          post?.repost?.id || post.id
                                        ] && (
                                          <LinkPreviewCard
                                            url={
                                              linkPreviewData[
                                                post?.repost?.id || post.id
                                              ].url
                                            }
                                            title={
                                              linkPreviewData[
                                                post?.repost?.id || post.id
                                              ].title
                                            }
                                            description={
                                              linkPreviewData[
                                                post?.repost?.id || post.id
                                              ].description
                                            }
                                            image={
                                              linkPreviewData[
                                                post?.repost?.id || post.id
                                              ].image
                                            }
                                            site_name={
                                              linkPreviewData[
                                                post?.repost?.id || post.id
                                              ].site_name
                                            }
                                            loading={
                                              !!linkPreviewData[
                                                post?.repost?.id || post.id
                                              ]._loading
                                            }
                                          />
                                        )}
                                      </div>
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                            : "ml-6  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];
                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0],
                                                    ) ? (
                                                      <div
                                                        className={`relative ${
                                                          post?.repost
                                                            ?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[300px] h-[350px] rounded-lg"
                                                              : "w-[780px] h-[400px] rounded-lg"
                                                            : isMobileView
                                                              ? "w-[300px] h-[350px] rounded-lg"
                                                              : "w-[780px] h-[400px] rounded-lg"
                                                        }`}
                                                      >
                                                        {/* {shouldShowThumbnail ? (
                                                    <div>
                                                      <img
                                                        src={image.thumb}
                                                        id={`image-${key}`}
                                                        className={
                                                          post?.repost
                                                            ?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                              : "w-[780px] h-[400px] object-contain rounded-lg "
                                                            : isMobileView
                                                            ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                            : "w-[780px] h-[400px]  object-contain rounded-lg "
                                                        }
                                                        alt="Video Thumbnail"
                                                        onClick={(e) => {
                                                          handleVideoClick(
                                                            index,
                                                            imageIndex
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                  : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autobuffer
                                                      controls
                                                      playsInline={true}
                                                      webkit-playsinline="true"
                                                      x5-playsinline="true"
                                                      x-webkit-airplay="deny"
                                                      disablePictureInPicture={
                                                        true
                                                      }
                                                      controlsList="nodownload"
                                                      onContextMenu={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      loop
                                                      autoPlay
                                                      id={`video-${key}`}
                                                      preload="auto"
                                                      className="w-full h-full object-contain rounded-lg"
                                                      onLoadedMetadata={(e) => {
                                                        if (isMobileView) {
                                                          e.target.currentTime = 1;
                                                        }
                                                      }}
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )} */}

                                                        {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                        <div
                                                          className="w-[780px] h-[400px] relative rounded-lg"
                                                          onClick={() =>
                                                            togglePlay(post.id)
                                                          }
                                                        >
                                                          {pausedVideoId ===
                                                            post.id && (
                                                            <div className="absolute inset-0 flex items-center justify-center z-10">
                                                              <FontAwesomeIcon
                                                                icon={faPlay}
                                                                className="text-green-500 text-5xl opacity-60"
                                                              />
                                                            </div>
                                                          )}

                                                          <video
                                                            id={post.id}
                                                            data-id={post.id}
                                                            ref={(el) =>
                                                              (videosRef.current[
                                                                post.id
                                                              ] = el)
                                                            }
                                                            poster={image.thumb}
                                                            src={image.image}
                                                            className="w-full max-h-full object-contain"
                                                            // onMouseEnter={() => handleVisibility(post.id, true)}
                                                            // onMouseLeave={() => handleVisibility(post.id, false)}
                                                            onClick={() =>
                                                              togglePlay(
                                                                post.id,
                                                              )
                                                            }
                                                            loop
                                                            muted={isMuted}
                                                            playsInline
                                                            onLoadedData={() =>
                                                              handleVideoCanPlay(
                                                                post.id,
                                                              )
                                                            }
                                                          />
                                                          {/* Mute button positioned inside the post at the bottom-right corner */}
                                                          <button
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // Prevent click from bubbling to parent
                                                              toggleMute();
                                                            }}
                                                            className="absolute bottom-4 right-4 px-4 py-2 text-sm"
                                                          >
                                                            {isMuted
                                                              ? "🔇"
                                                              : "🔊"}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index,
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              },
                                            )
                                          : post.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];

                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0],
                                                    ) ? (
                                                      <div
                                                        className={`relative ${
                                                          post?.repost
                                                            ?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[300px] h-[350px] rounded-lg"
                                                              : "w-[780px] h-[400px] rounded-lg"
                                                            : isMobileView
                                                              ? "w-[300px] h-[350px] rounded-lg"
                                                              : "w-[780px] h-[400px] rounded-lg"
                                                        }`}
                                                      >
                                                        {/* {shouldShowThumbnail ? (
                                                    <div>
                                                      <img
                                                        src={image.thumb}
                                                        id={`image-${key}`}
                                                        className={
                                                          post?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                              : "w-[780px] h-[400px] object-contain rounded-lg "
                                                            : isMobileView
                                                            ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                            : "w-[780px] h-[400px]  object-contain rounded-lg "
                                                        }
                                                        alt="Video Thumbnail"
                                                        onClick={(e) => {
                                                          handleVideoClick(
                                                            index,
                                                            imageIndex
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      controls
                                                      autoPlay
                                                      autobuffer
                                                      playsInline={true}
                                                      webkit-playsinline="true"
                                                      x5-playsinline="true"
                                                      x-webkit-airplay="deny"
                                                      disablePictureInPicture={
                                                        true
                                                      }
                                                      onContextMenu={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      preload="auto"
                                                      id={`video-${key}`}
                                                      className="w-full h-full object-contain rounded-lg"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )}

                                                  <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() =>
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      )
                                                    }
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                        <div
                                                          className="w-[780px] h-[400px] object-contain rounded-lg"
                                                          onClick={() =>
                                                            togglePlay(post.id)
                                                          }
                                                        >
                                                          {pausedVideoId ===
                                                            post.id && (
                                                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                              <FontAwesomeIcon
                                                                icon={faPlay}
                                                                className="text-green-500 text-3xl opacity-60"
                                                              />
                                                            </div>
                                                          )}

                                                          <video
                                                            id={post.id}
                                                            data-id={post.id}
                                                            ref={(el) =>
                                                              (videosRef.current[
                                                                post.id
                                                              ] = el)
                                                            }
                                                            poster={image.thumb}
                                                            src={image.image}
                                                            className="w-full max-h-full object-contain"
                                                            // onMouseEnter={() => handleVisibility(post.id, true)}
                                                            // onMouseLeave={() => handleVisibility(post.id, false)}
                                                            onClick={() =>
                                                              togglePlay(
                                                                post.id,
                                                              )
                                                            }
                                                            loop
                                                            muted={isMuted}
                                                            playsInline
                                                            onLoadedData={() =>
                                                              handleVideoCanPlay(
                                                                post.id,
                                                              )
                                                            }
                                                          />
                                                          {/* Mute button positioned inside the post at the bottom-right corner */}
                                                          <button
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // Prevent click from bubbling to parent
                                                              toggleMute();
                                                            }}
                                                            className="absolute bottom-4 right-4 px-4 py-2 text-sm"
                                                          >
                                                            {isMuted
                                                              ? "🔇"
                                                              : "🔊"}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        {" "}
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index,
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              },
                                            )}
                                      </div>
                                      <div className="flex flex-row md:ml-8 ml-[2.8rem] justify-between items-center px-4 sm:px-8 my-4 text-green-500 space-x-4">
                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon icon={empty2} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post.user_id
                                                : "",
                                              post.id,
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          <FontAwesomeIcon icon={faRepeat} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post.total_likes,
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          )}

                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>
                                        </button>

                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleSavePost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_saved
                                                  ? saved
                                                  : faBookmark
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post.is_saved
                                                  ? saved
                                                  : faBookmark
                                              }
                                            />
                                          )}
                                        </button>
                                        {isModalOpen && newid === post.id && (
                                          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">
                                            <div className="bg-white p-6 rounded shadow-lg">
                                              {/* Modal content goes here */}
                                              <p>Delete this post? This can't be undone.</p>
                                              <button onClick={handleCloseModal} className="bg-gray-500 text-white py-2 px-4 rounded mt-4 mr-2">Cancel</button>
                                              <button onClick={handleDelete} className="bg-red-500 text-white py-2 px-4 rounded mt-4">Delete</button>
                                            </div>
                                          </div>
                                        )}

                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowUpFromBracket}
                                          />
                                        </button>
                                      </div>
                                      {commentOpenStates[index] && (
                                        <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                          <div className="mt-4 space-y-2">
                                            {!loadingComment &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ] &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].length > 0 ? (
                                              postComments[
                                                post?.repost?.id
                                                  ? post?.repost?.id
                                                  : post.id
                                              ].map((comment) => (
                                                <div
                                                  key={comment.id}
                                                  className="flex items-start mb-2"
                                                >
                                                  <div className="flex-shrink-0">
                                                    <img
                                                      src={comment?.user?.image}
                                                      alt={`${comment?.user?.user_name}'s avatar`}
                                                      className="w-8 h-8 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                      onClick={(e) =>
                                                        navigateToUserProfile(
                                                          e,
                                                          comment?.user?.id,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className="w-full">
                                                    <div className="flex justify-between mb-1">
                                                      <span
                                                        className="font-semibold ml-2 cursor-pointer hover:underline"
                                                        onClick={(e) =>
                                                          navigateToUserProfile(
                                                            e,
                                                            comment?.user?.id,
                                                          )
                                                        }
                                                      >
                                                        {
                                                          comment?.user
                                                            ?.user_name?.replace(/^@/, "")
                                                        }
                                                      </span>
                                                      {comment?.user.id ===
                                                        profile?.id && (
                                                        <button
                                                          disabled={
                                                            isDisabled
                                                              ? true
                                                              : false
                                                          }
                                                          className="px-5 text-green-500 "
                                                          onClick={() =>
                                                            handleDeleteComment(
                                                              comment.id,
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTrash}
                                                          />
                                                        </button>
                                                      )}
                                                    </div>
                                                    <div className="flex justify-between">
                                                      <div
                                                        className={
                                                          "md:w-full w-52 ml-2"
                                                        }
                                                      >
                                                        {comment?.comment && (
                                                          <p
                                                            className="w-full break-words text-sm"
                                                            style={{
                                                              whiteSpace:
                                                                "pre-wrap",
                                                              wordBreak:
                                                                "break-word",
                                                            }}
                                                          >
                                                            {comment?.comment}
                                                          </p>
                                                        )}
                                                        {comment?.image && (
                                                          <img
                                                            src={comment.image}
                                                            alt="Comment image"
                                                            className="mt-1.5 rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                                                            loading="lazy"
                                                            onClick={() =>
                                                              openCommentImage(
                                                                comment.image,
                                                              )
                                                            }
                                                          />
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            ) : loadingComment ? (
                                              <ListSkeleton
                                                rows={2}
                                                avatarSize={32}
                                                columns={0}
                                                divided={false}
                                                rowClassName="py-3 px-4"
                                              />
                                            ) : (
                                              !loadingComment && (
                                                <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                  <p>No comments yet</p>
                                                </div>
                                              )
                                            )}
                                          </div>
                                          <div
                                            className={`mt-4 relative ${
                                              postId ? "mb-[60px]" : ""
                                            }`}
                                          >
                                            {commentImagePreview && (
                                              <div className="mb-2 relative inline-block">
                                                <img
                                                  src={commentImagePreview}
                                                  alt="Preview"
                                                  className="h-20 w-20 object-cover rounded-lg border border-gray-200"
                                                />
                                                <button
                                                  className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                                                  onClick={() => {
                                                    setCommentImage(null);
                                                    setCommentImagePreview(
                                                      null,
                                                    );
                                                  }}
                                                >
                                                  &times;
                                                </button>
                                              </div>
                                            )}
                                            <div className="flex">
                                              <textarea
                                                value={newComment}
                                                onChange={(e) =>
                                                  setNewComment(e.target.value)
                                                }
                                                placeholder="Add a comment..."
                                                className="p-2 border border-emerald-500 rounded w-full text-black"
                                                style={{
                                                  flex: 1,
                                                  resize: "none",
                                                  maxHeight: "150px",
                                                  overflowY: "auto",
                                                }}
                                                rows={3}
                                              />

                                              <div className="flex flex-col ml-2 gap-1">
                                                <button
                                                  className="bg-gray-200 hover:bg-gray-300 text-gray-600 px-2 rounded-full focus:outline-none flex items-center justify-center"
                                                  onClick={() =>
                                                    commentImageInputRef.current?.click()
                                                  }
                                                  style={{
                                                    height: 30,
                                                    minWidth: 84,
                                                  }}
                                                >
                                                  <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="mr-1"
                                                  >
                                                    <rect
                                                      x="3"
                                                      y="3"
                                                      width="18"
                                                      height="18"
                                                      rx="2"
                                                      ry="2"
                                                    />
                                                    <circle
                                                      cx="8.5"
                                                      cy="8.5"
                                                      r="1.5"
                                                    />
                                                    <polyline points="21 15 16 10 5 21" />
                                                  </svg>
                                                  Image
                                                </button>
                                                <button
                                                  className="bg-primaryColor text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                                  disabled={
                                                    isDisabled ||
                                                    (!newComment.trim() &&
                                                      !commentImage)
                                                  }
                                                  onClick={() =>
                                                    handleAddComment(
                                                      post?.repost?.id
                                                        ? post?.repost?.id
                                                        : post.id,
                                                      index,
                                                    )
                                                  }
                                                  style={{
                                                    height: 30,
                                                    minWidth: 84,
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="w-full mt-3 h-px bg-gray-300 md:hidden">
                                        No post found
                                      </div>{" "}
                                      {/* Full width line separator */}
                                    </div>
                                  )}
                                  {index === 1 && <MarketVoteCard />}
                                </React.Fragment>
                              );
                            })
                        : posts.length === 0 &&
                          postId &&
                          !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                              <p>No posts available.</p>
                            </div>
                          )}
                    </div>
                    {/* {posts.length === 0 && (
                          <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                            <p>No posts available.</p>
                          </div>
                        )} */}
                    {/* </>
)} */}
                  </InfiniteScroll>
                  {/* </div> */}
                </main>
              </div>
            </div>
          </div>
        </div>
      </Shell>
      <UndoRepostModal
        isOpen={postUndo}
        handleUndoRepost={handleUndoRepost}
        handleUndoCancel={handleUndoCancel}
      >
        <div className={"mb-4"}>
          <p>{"Are you sure you want to undo this reposted post?"}</p>
        </div>
      </UndoRepostModal>
      <BlockReportModal
        isOpen={isBlockOpen}
        type={postType}
        handleBlockUser={handleBlockUser}
        handleReportPost={handleReportPost}
        handleBlockUserCancel={handleBlockUserCancel}
      >
        <div className={postType === "block" ? "mb-4" : ""}>
          <p>
            {postType === "block"
              ? "Are you sure you want to block this user?"
              : "Are you sure you want to report this post?"}
          </p>
        </div>
        {postType === "block" ? (
          ""
        ) : (
          <div className="mt-4 mb-4">
            <textarea
              value={reportComment}
              className="w-full px-4 py-3 rounded-lg border-2 border-gray-200"
              placeholder="Please enter comment here"
              onChange={(e) => setReportComment(e.target.value)}
            />
          </div>
        )}
      </BlockReportModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}

      {!showFeedGuide && guideIcon && !isSidebarOpen && (
        <button
          type="button"
          className={`fixed text-white p-0.5 rounded-full shadow-lg hover:opacity-90 z-50 select-none ${
            isGuideDragging ? "cursor-grabbing" : "cursor-grab"
          }`}
          style={{
            bottom: `${guideButtonPosition.bottom}px`,
            right: `${guideButtonPosition.right}px`,
            touchAction: "none",
            backgroundColor: "#35b23c",
          }}
          onClick={() =>
            !hasGuideDraggedSignificantly && setShowFeedGuide(true)
          }
          onMouseDown={handleGuideDragStart}
          onTouchStart={handleGuideDragStart}
          title="Drag to move • Click to show guide (Ctrl+G)"
          aria-label="Feed guide"
        >
          <svg width="40" height="40" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}

      {showFeedGuide && <FeedGuideSteps setShowGuide={setShowFeedGuide} />}

      {/* Mobile Comment Modal - Instagram Style */}
      {mobileCommentModal.isOpen && (
        <div
          ref={commentModalRef}
          className="fixed inset-0 z-[9999] md:hidden"
          style={{
            touchAction: "none",
            height: "100%",
            height: "100dvh",
          }}
        >
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => {
              setMobileCommentModal({
                isOpen: false,
                postId: null,
                postIndex: null,
              });
              setNewComment("");
              setReplyingTo(null);
            }}
          />

          {/* Modal Content - Dynamic height that adjusts for keyboard */}
          <div
            className="absolute left-0 right-0 bg-white rounded-t-3xl flex flex-col"
            style={{
              animation: commentModalSwipe.isDragging
                ? "none"
                : "slideUp 0.3s ease-out",
              bottom: 0,
              maxHeight:
                keyboardHeight > 0
                  ? `calc(100dvh - ${keyboardHeight}px)`
                  : "80vh",
              height: "auto",
              minHeight: keyboardHeight > 0 ? "200px" : "65vh",
              transform: `translateY(${Math.max(0, commentModalSwipe.currentY - commentModalSwipe.startY)}px)`,
              transition: commentModalSwipe.isDragging
                ? "none"
                : "max-height 0.15s ease-out, min-height 0.15s ease-out, transform 0.3s ease-out",
            }}
          >
            {/* Header - Drag handle area */}
            <div
              className="flex items-center justify-center py-2.5 border-b border-gray-200 relative flex-shrink-0 cursor-grab"
              onTouchStart={(e) => {
                setCommentModalSwipe({
                  startY: e.touches[0].clientY,
                  currentY: e.touches[0].clientY,
                  isDragging: true,
                });
              }}
              onTouchMove={(e) => {
                if (commentModalSwipe.isDragging) {
                  setCommentModalSwipe((prev) => ({
                    ...prev,
                    currentY: e.touches[0].clientY,
                  }));
                }
              }}
              onTouchEnd={() => {
                const swipeDistance =
                  commentModalSwipe.currentY - commentModalSwipe.startY;
                if (swipeDistance > 80) {
                  // Close the modal if swiped down more than 80px
                  setMobileCommentModal({
                    isOpen: false,
                    postId: null,
                    postIndex: null,
                  });
                  setNewComment("");
                  setReplyingTo(null);
                }
                setCommentModalSwipe({
                  startY: 0,
                  currentY: 0,
                  isDragging: false,
                });
              }}
            >
              <div className="absolute left-1/2 transform -translate-x-1/2 top-1.5 w-10 h-1 bg-gray-300 rounded-full" />
              <h3 className="font-semibold text-base mt-1">Comments</h3>
              {/* <button
                className="absolute right-4 top-2 p-1"
                onClick={() => {
                  setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
                  setNewComment("");
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button> */}
            </div>

            {/* Comments List - Scrollable area */}
            <div
              data-comment-scroll
              className="flex-1 overflow-y-auto px-4 py-2 overscroll-contain"
              style={{
                minHeight: "80px",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {loadingComment ? (
                <ListSkeleton
                  rows={3}
                  avatarSize={32}
                  columns={0}
                  divided={false}
                  rowClassName="py-3"
                />
              ) : postComments[mobileCommentModal.postId]?.length > 0 ? (
                postComments[mobileCommentModal.postId].map((comment) => (
                  <div key={comment.id} className="mb-5">
                    <div className="flex items-start">
                      <img
                        src={comment?.user?.image}
                        alt={`${comment?.user?.user_name}'s avatar`}
                        className="w-10 h-10 rounded-full mr-3 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={(e) =>
                          navigateToUserProfile(e, comment?.user?.id)
                        }
                      />
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <span
                            className="font-semibold text-base cursor-pointer hover:underline"
                            onClick={(e) =>
                              navigateToUserProfile(e, comment?.user?.id)
                            }
                          >
                            {comment?.user?.user_name?.replace(/^@/, "")}
                          </span>
                          <span className="text-sm text-gray-400">
                            {comment?.created_at
                              ? calculateTimeAgo(comment.created_at)
                              : ""}
                          </span>
                        </div>
                        {comment?.comment && (
                          <p
                            className="text-[17px] leading-snug text-gray-800 mt-1"
                            style={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {comment?.comment}
                          </p>
                        )}
                        {comment?.image && (
                          <img
                            src={comment.image}
                            alt="Comment image"
                            className="mt-1.5 rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                            loading="lazy"
                            onClick={() => openCommentImage(comment.image)}
                          />
                        )}
                        {/* Reply button + View replies */}
                        <div className="flex items-center gap-3 mt-1.5">
                          <button
                            className="text-xs text-gray-500 font-semibold"
                            onClick={() =>
                              handleReply(comment, mobileCommentModal.postId)
                            }
                          >
                            Reply
                          </button>
                          {comment.replies_count > 0 && (
                            <button
                              className="text-xs text-blue-500 font-semibold"
                              onClick={() => toggleReplies(comment.id)}
                            >
                              {expandedReplies[comment.id]
                                ? "Hide replies"
                                : `View ${comment.replies_count} ${comment.replies_count === 1 ? "reply" : "replies"}`}
                            </button>
                          )}
                        </div>
                      </div>
                      {comment?.user?.id === profile?.id && (
                        <button
                          className="ml-2 p-1.5 text-green-500 hover:text-green-600 flex-shrink-0"
                          onClick={() => handleDeleteComment(comment.id)}
                          disabled={isDisabled}
                          title="Delete comment"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                          </svg>
                        </button>
                      )}
                    </div>
                    {/* Nested replies */}
                    {expandedReplies[comment.id] &&
                      comment.replies?.length > 0 && (
                        <div className="ml-12 mt-2 space-y-3 border-l-2 border-gray-200 pl-3">
                          {comment.replies.map((reply) => (
                            <div key={reply.id} className="flex items-start">
                              <img
                                src={reply?.user?.image}
                                alt={`${reply?.user?.user_name}'s avatar`}
                                className="w-7 h-7 rounded-full mr-2 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
                                onClick={(e) =>
                                  navigateToUserProfile(e, reply?.user?.id)
                                }
                              />
                              <div className="flex-1">
                                <div className="flex items-center gap-2">
                                  <span
                                    className="font-semibold text-base cursor-pointer hover:underline"
                                    onClick={(e) =>
                                      navigateToUserProfile(e, reply?.user?.id)
                                    }
                                  >
                                    {reply?.user?.user_name?.replace(/^@/, "")}
                                  </span>
                                  <span className="text-xs text-gray-400">
                                    {reply?.created_at
                                      ? calculateTimeAgo(reply.created_at)
                                      : ""}
                                  </span>
                                </div>
                                {reply?.comment && (
                                  <p
                                    className="text-[17px] leading-snug text-gray-800 mt-0.5"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {reply.comment}
                                  </p>
                                )}
                                {reply?.image && (
                                  <img
                                    src={reply.image}
                                    alt="Reply image"
                                    className="mt-1 rounded-lg max-w-[150px] max-h-[150px] object-cover cursor-pointer"
                                    loading="lazy"
                                    onClick={() =>
                                      openCommentImage(reply.image)
                                    }
                                  />
                                )}
                                <button
                                  className="text-xs text-gray-500 font-semibold mt-1"
                                  onClick={() =>
                                    handleReply(
                                      comment,
                                      mobileCommentModal.postId,
                                    )
                                  }
                                >
                                  Reply
                                </button>
                              </div>
                              {reply?.user?.id === profile?.id && (
                                <button
                                  className="ml-1 p-1 text-green-500 hover:text-green-600 flex-shrink-0"
                                  onClick={() => handleDeleteComment(reply.id)}
                                  disabled={isDisabled}
                                >
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                ))
              ) : (
                <div className="text-center py-8">
                  <p className="text-gray-500 font-medium">No comments yet</p>
                  <p className="text-gray-400 text-sm mt-1">
                    Start the conversation.
                  </p>
                </div>
              )}
            </div>

            {/* Comment Input - Stays above keyboard */}
            <div
              className="border-t border-gray-200 px-3 py-2.5 bg-white flex-shrink-0"
              style={{
                paddingBottom: "max(10px, env(safe-area-inset-bottom))",
              }}
            >
              {/* Replying to indicator */}
              {replyingTo && (
                <div className="flex items-center justify-between px-3 py-1.5 bg-gray-50 rounded-t mb-1">
                  <span className="text-xs text-gray-600">
                    Replying to{" "}
                    <span className="font-semibold">
                      @{replyingTo.userName?.replace(/^@/, "")}
                    </span>
                  </span>
                  <button
                    className="text-xs text-blue-500 font-semibold"
                    onClick={handleCancelReply}
                  >
                    Cancel
                  </button>
                </div>
              )}
              {/* Emoji quick-bar */}
              <div className="flex items-center justify-around px-2 py-1.5">
                {["❤️", "📈", "🔥", "👏", "💪", "✨", "🤣", "🚀"].map(
                  (emoji) => (
                    <button
                      key={emoji}
                      className="text-3xl p-1 active:scale-125 transition-transform"
                      onClick={() => setNewComment((prev) => prev + emoji)}
                    >
                      {emoji}
                    </button>
                  ),
                )}
              </div>
              <div className="flex items-end gap-2">
                <img
                  src={profile?.image || Default}
                  alt="Your avatar"
                  className="w-10 h-10 rounded-full flex-shrink-0 mb-1"
                />
                {/* Image attach button */}
                <button
                  className="w-8 h-8 mb-1 flex items-center justify-center flex-shrink-0 text-gray-500 hover:text-gray-700"
                  onClick={() => commentImageInputRef.current?.click()}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                  </svg>
                </button>
                <div className="flex-1 flex flex-col bg-gray-100 rounded-2xl pr-1">
                  {/* Image preview inside the input box */}
                  {commentImagePreview && (
                    <div className="px-3 pt-2 relative inline-block self-start">
                      <img
                        src={commentImagePreview}
                        alt="Preview"
                        className="h-14 w-14 object-cover rounded-lg border border-gray-300"
                      />
                      <button
                        className="absolute top-1 right-0 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                        onClick={() => {
                          setCommentImage(null);
                          setCommentImagePreview(null);
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  )}
                  <div className="flex items-end">
                    <div className="flex-1">
                      <textarea
                        ref={commentTextareaRef}
                        value={newComment}
                        onChange={(e) => {
                          setNewComment(e.target.value);
                          // Auto-grow up to 4 full lines; scroll activates at line 5
                          e.target.style.height = "auto";
                          const maxH = 112;
                          if (e.target.scrollHeight > maxH) {
                            e.target.style.height = maxH + "px";
                            e.target.style.overflowY = "auto";
                          } else {
                            e.target.style.height =
                              e.target.scrollHeight + "px";
                            e.target.style.overflowY = "hidden";
                          }
                        }}
                        onFocus={(e) => {
                          // Ensure input stays visible when keyboard opens
                          setTimeout(() => {
                            e.target.scrollIntoView({
                              behavior: "smooth",
                              block: "nearest",
                            });
                          }, 300);
                        }}
                        placeholder="Add a comment..."
                        className="w-full bg-transparent px-4 py-2 text-base focus:outline-none text-black resize-none block"
                        style={{
                          maxHeight: "112px",
                          lineHeight: "24px",
                          WebkitOverflowScrolling: "touch",
                          touchAction: "pan-y",
                        }}
                        rows={1}
                        enterKeyHint="send"
                        autoComplete="off"
                        autoCorrect="on"
                        onKeyDown={(e) => {
                          if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            (newComment.trim() || commentImage)
                          ) {
                            e.preventDefault();
                            handleAddComment(
                              mobileCommentModal.postId,
                              mobileCommentModal.postIndex,
                            );
                          }
                        }}
                      />
                    </div>
                    <button
                      className={`w-8 h-8 mb-1 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                        newComment.trim() || commentImage
                          ? "bg-primaryColor"
                          : "bg-gray-300"
                      }`}
                      disabled={
                        isDisabled || (!newComment.trim() && !commentImage)
                      }
                      onClick={() =>
                        handleAddComment(
                          mobileCommentModal.postId,
                          mobileCommentModal.postIndex,
                        )
                      }
                    >
                      {
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M22 2L11 13" />
                          <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                        </svg>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CSS Animation */}
          <style>{`
            @keyframes slideUp {
              from {
                transform: translateY(100%);
              }
              to {
                transform: translateY(0);
              }
            }
            @supports (-webkit-touch-callout: none) {
              .comment-modal-input:focus {
                position: relative;
                z-index: 10;
              }
            }
          `}</style>
        </div>
      )}
      {newTraderGuideActive &&
        newTraderGuideStep === 5 &&
        localStorage.getItem("qushi_onboarding_persona") === "creator" && (
          <NewTraderGuide step={5} />
        )}
    </>
  );
};

export default FeedPage;
